import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { Subject, BehaviorSubject } from 'rxjs';
import { StructureTagService } from '../services/structureTag.service';
import { TimeZoneService } from '../services/time-zone.service';
import { ToastService } from '../shared/custom-overlay/toast/toast.service';
import { ErrorMsgHandler } from '../shared/errormanagement/handleerror';
import { AlertActionManagement } from './statemanagement/action-management';
import { TimeDiffCalc } from './timecalc/timecalc';
import { cdkOverlayRef } from '../shared/custom-overlay/cdk-overlay-ref';
import { AlertsService } from './alerts-custom.service';
import * as d3 from 'node_modules/d3'
import * as echarts from "echarts";
import { ValueValidator } from '../designer/validator/fieldValueValidator';
import { AdvanceFilterComponent } from './template/advance-filter/advance-filter.component';
import { CdkOverlyayService } from '../shared/custom-overlay/cdk-overlyay.service';
import { SharedService } from '../services/shared.service';
import { EditorView } from 'codemirror';
import { Observable, of } from 'rxjs';
import { Action } from 'rxjs/internal/scheduler/Action';
import { QueryEditorService } from '../language-service/query-editor.service';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as loadash from 'lodash';

//expansion panel states

export enum FactsheetEventsPanel {
  closed = 0,
  collapse = 1,
  expand = 2
}

export enum FactsheetSummaryPanel {
  closed = 0,
  collapse = 1,
  expand = 2
}


@Injectable({
  providedIn: 'root'
})
export class AlertsvarService {
  already_using_msg = "Alert already being reviewed. Would you like to override ?";
  // already_login_warning_msg = "An active session exists. Would you like to terminate that session?";
  constructor(
    public sharedService: SharedService,
    private timezoneservice: TimeZoneService,
    private toasterservice: ToastService,
    private structureTagsService: StructureTagService,
    private cdkoverlayDialog: CdkOverlyayService,
    private alertService: AlertsService,
    private queryEditorService: QueryEditorService) {
    this.queryValidator = this.queryValidator.bind(this);
    this.sharedService.$metaData.subscribe((metadata: any) => {
      this.alertsheetmeta = JSON.parse(JSON.stringify(metadata.alert));
      this.commondata = metadata.commonData;
      this.resetalertvariableon();
      this.resetfactsheetvariableson();
      this.processdefaultalertfilters()
    })

    this.sharedService.customerChanged_.subscribe(() => this.alertUserReset())

    this.sharedService.userLoggedoff_.subscribe(() => {
      this.resetalertvariablesoff();
      this.resetfactsheetvariablesoff();
      this.resetFactsheetPanels();
      
    })

    

    this.sharedService.$metaDataUpdated.subscribe(val=>{
// console.log(val)
      this.setdefaultAlertFilter()
    })
  }

  // current_user_id = this.sharedService.getCurrentUserId()

  alert_tab_metadata = {
    "labels":{"gloabal_filter":"Global alert filters","global_filters_title":"GLOBAL ALERT FILTERS","active":"ACTIVE","reset_filter":"Reset All Filters","severity":"SEVERITY",
      "active_filter":"Active Filters","selected_state":"Selected State","clear_all":"Clear all"},
    "placeholders":{"severity":"All Severities","state":"All States","platform":"All Platforms"},
    "default_values":{"other_analyst_states":[1,2,3,4]}
    
  }

  actionPanel

  onTimeChange(value: any,dataset:any): void {
    // Remove existing time chip
    this.selectedGlobalFilters = this.selectedGlobalFilters.filter(
      filter => filter.type !== 'TIME'
    );
  
    // Don't create a chip if it is the default
    if (value == this.default_summary_time_filter) {
      return;
    }
  
    this.selectedGlobalFilters.push({
      type: 'TIME',
      value: value,
      disp: this.selectedValueDispMap(value,dataset)
    });
  }

  selectedValueDispMap(value:any,dataset:any){
    let matched = dataset.find(item => item.value === value)
    if(matched){
      return matched.disp
    }
    return value
  }

  onSeverityChange(values: string[],dataset:any): void {
    if (!values || values.length === 0) {
      this.selectedGlobalFilters = this.selectedGlobalFilters.filter(
        item => item.type !== 'SEVERITY'
      );
      return;
    }
  
    // Add newly selected values
    values.forEach(value => {
      const exists = this.selectedGlobalFilters.some(
        item =>
          item.type === 'SEVERITY' &&
          item.value === value
      );
  
      if (!exists) {
        this.selectedGlobalFilters.push({
          type: 'SEVERITY',
          value: value,
          disp: this.selectedValueDispMap(value,dataset)
        });
      }
    });
  
    // Remove values that were unselected
    this.selectedGlobalFilters = this.selectedGlobalFilters.filter(item => {
  
      if (item.type !== 'SEVERITY') {
        return true;
      }
  
      return values.includes(item.value);
    });
  }

  onalertStateChange(values: string[],dataset:any): void {
    if (!values || values.length === 0) {
      this.selectedGlobalFilters = this.selectedGlobalFilters.filter(
        item => item.type !== 'STATE'
      );
      return;
    }
  
    // Add newly selected values
// console.log("values======",values)
    if (!values.includes("all")) {
      values.forEach(value => {
      const exists = this.selectedGlobalFilters.some(
      item =>
        item.type === 'STATE' &&
        item.value === value
      );
  
      if (!exists) {
        this.selectedGlobalFilters.push({
          type: 'STATE',
          value: value,
          disp: this.selectedValueDispMap(value,dataset)
        });
      }
      
    });
    }
    
  
    // Remove values that were unselected
    this.selectedGlobalFilters = this.selectedGlobalFilters.filter(item => {
  
      if (item.type !== 'STATE') {
        return true;
      }
  
      return values.includes(item.value);
    });
  }

  removeFilter(filter:any): void {

    // Remove chip
    this.selectedGlobalFilters = this.selectedGlobalFilters.filter(
      item =>
        !(item.type === filter.type && item.value === filter.value)
    );
  
    if (filter.type === 'STATE') {
  
      const currentValues = this.alertStateFilter.value || [];
  
      const newValues = currentValues.filter(
        value => value !== filter.value
      );
  
// console.log("newvalues===",newValues)
      this.alertStateFilter.reset()
      this.alertStateFilter.setValue(newValues,{emitEvent:true});
  
// console.log(this.alertStateFilter.value)
    }
  
    if (filter.type === 'TIME') {
      this.alertTimeFilter.setValue(this.default_summary_time_filter, {
        emitEvent: false
      });
    }
    if (filter.type === 'ANALYST') {
      this.alertAnalystFilter.setValue(this.sharedService.getCurrentUserId(), {
        emitEvent: false
      });
    }
  }

  alertLandingStatusTabSelectedIndex: number = 0;
  alertSummaryTimeFilter = new FormControl()
  default_summary_time_filter = [-1,"hour",24]
  alertSummaryServerityFilter = new FormControl()
  alertSummaryAssignedUserFilter = new FormControl()

  alertTimeFilter = new FormControl(this.default_summary_time_filter)
  alertSeverityFilter = new FormControl(["all"])
  alertStateFilter: any = new FormControl(["all"])
  alertPlatformFilter = new FormControl(["all"])
  alertAnalystFilter = new FormControl(this.sharedService.getCurrentUserId())

  selectedGlobalFilters:any = [];

  allRows=[]
  triggeredRows=[]
  ackRows=[]
  waitingRows=[]
  reassignRows=[]
  alltabRows=[]

  alertStatusSelectedIndex=0

  mockRequest={
    "itemPerPage": 15,
    "page": 1,
    "alertcount": [
        "greater",
        0
    ],
    "alertpercentage": [
        "greater",
        0
    ],
    "severity": [],
    "timezone": "localbrowser",
    "timerange": [
        "2025-10-31 18:30:00",
        "2026-08-27 08:30:33"
    ],
    "platform": "firewall_fortigate",
    "impactedHost": {
        "selectedHosts": [],
        "toggleControl": false,
        "uniqueHostsLength": 0,
        "selectedTags": [],
        "excludedHosts": {}
    },
    "tags": {
        "killchain": [],
        "compliance": [],
        "mitreattack": [],
        "threatgroup": []
    },
    "status": [],
    "title": [],
    "data_type": [],
    "observable": [],
    "signature": [],
    "token": "c4253bb7",
    "request_type": "process",
    "topicfilter": [
        "/alerts/summary_onfilter/get"
    ]
}

mockEvents={
  "alertcount": 1,
  "eventList": [
    {
      "alerttime": 1787786887,
      "seq_no": 46334,
      "status": 0,
      "assigned_user": null,
      "eventdetails": {
        "time": "2026-08-26 23:28:07",
        "srcip": "198.235.24.198",
        "dstip": "103.8.188.211",
        "dstport": 444,
        "service": "TCP",
        "sum_sentbyte": 44,
        "sum_rcvdbyte": 40
      },
      "eventcount": 1
    }
  ]
}

  dedupId=""
  dedupData={"alertId":"","status":0}

  dedupDialogRef

  mockdedup= {"fields": [
    {
      "disp": "time",
      "cardinality": "Medium"
    },
    {
      "disp": "action",
      "cardinality": "Low"
    },
    {
      "disp": "srcip",
      "cardinality": "High"
    },
    {
      "disp": "dstip",
      "cardinality": "Very high"
    }
  ]
}

landingTitles={
  "alert_title":"Alert Investigation",
  "alert_context":"Investigate security alerts. Expand any alert to inspect detailed alert graph."
}

landingTooltip={
  "expand_nav":"Expand Navigation",
  "collapse_nav":"Collapse Navigation",
  "refresh":"Refresh"
}

severity={
  "critical": {
    "color": "#e02200",
    "background-color": "#fff5f5",
    "border-color": "#fca5a5"
  },
  "high": {
    "color": "#eb8d00",
    "background-color": "#fffcf0",
    "border-color": "#fed7aa"
  },
  "medium": {
    "color": "#d97706",
    "background-color": "#fffcf0",
    "border-color": "#fed7aa"
  },
  "low": {
    "color": "#2f8400",
    "background-color": "#f0fff0",
    "border-color": "#bbf7d0"
  },
  "informational":{
    "color": "#0079b8",
    "background-color": "#eef7fc",
    "border-color": "#bce1f5"
  }
}

stats={
  "critical":{
    "disp":"CRITICAL",
    "color":"#e02200",
    "bg-color":"#fff5f5",
    "border-color":"#fca5a5",
    "count":0,
    "percentage":0,
    "icon":"bolt",
    "diff":0
  },
  "high":{
    "disp":"HIGH",
    "color":"#eb8d00",
    "bg-color":"#fffcf0",
    "border-color":"#fed7aa",
    "count":0,
    "percentage":0,
    "icon":"warning",
    "diff":0
  },
    "medium":{
    "disp":"MEDIUM",
    "color":"#d97706",
    "bg-color":"#fffcf0",
    "border-color":"#fed7aa",
    "count":0,
    "percentage":0,
    "icon":"error",
    "diff":0
  },
  "low":{
    "disp":"LOW",
    "color":"#2f8400",
    "bg-color":"#f0fff0",
    "border-color":"#bbf7d0",
    "count":0,
    "percentage":0,
    "icon":"check_circle",
    "diff":0
  },
  "informational":{
    "disp":"INFORMATIONAL",
    "color":"#0079b8",
    "bg-color":"#eef7fc",
    "border-color":"#0079b8",
    "count":0,
    "percentage":0,
    "icon":"info",
    "diff":0
  }
}

dedupTitles={
  "dedup_title":"De-duplicate Alerts",
  "dedup_context":"Select the fields that should be used to identify and group duplicate alerts.",
  "group_alerts":"Group alerts by",
  "groupby_context":"Alerts with the same values for all selected fields will be grouped into a single alert.",
  "groupby_time":"Grouping time window",
  "time_context":"Only alerts occurring within this time period will be considered for the same duplicate group.",
  "selected":"Selected grouping fields",
  "selected_placeholder":"Select at least one field above",
  "cancel":"CANCEL",
  "apply_dedup":"APPLY DE-DUPLICATION",
  "result_header":"De-duplicated Alert Results",
  "result_context": "Grouped alerts based on selected criteria within the ",
  "window":" window",
  "group_generated":" Group Generated",
  "groups_generated":" Groups Generated",
  "acknowledge":"Acknowledge"
}

dedup_th=[
  "FROM TIMESTAMP",
  "TO TIMESTAMP",
  "LIST OF VALUES",
  "ALERT COUNT",
  "EVENT COUNT",
  "ACTION"
]

// statusStyle={
//   0:{
//     "border-color":"#ffc9c9",
//     "background-color":"#fef2f2",
//     "color":"#c10007"
//   },
//   1:{
//     "border-color":"#ffd230",
//     "background-color":"#fffbeb",
//     "color":"#973c00"
//   },
//   3:{
//     "border-color":"#bedbff",
//     "background-color":"#eff6ff",
//     "color":"#1447e6"
//   },
//   2:{
//     "border-color":"#b9f8cf",
//     "background-color":"#f0fdf4",
//     "color":"#008236"
//   },
//   4:{
//     "border-color":"#c6d2ff",
//     "background-color":"#eef2ff",
//     "color":"#432dd7"
//   },
//   5:{
//     "border-color":"#e9d4ff",
//     "background-color":"#faf5ff",
//     "color":"#8200db"
//   }
 

// }

statusStyle={
  "0": {
    "border-color": "#d1d5dc",
    "background-color": "#f6f3f4",
    "color": "#364153"
  },
  "1": {
    "border-color": "#bedbff",
    "background-color": "#eff6ff",
    "color": "#1447e6"
  },
  "2": {
    "border-color": "#a4f4cf",
    "background-color": "#ecfdf5",
    "color": "#007a55"
  },
  "3": {
    "border-color": "#bce1f5",
    "background-color": "#eef7fc",
    "color": "#0079b8"
  },
  "4": {
    "border-color": "#fee685",
    "background-color": "#fffbeb",
    "color": "#973c00"
  },
  "5": {
    "border-color": "#ffc9c9",
    "background-color": "#fef2f2",
    "color": "#c10007"
  },
  "6": {
    "border-color": "#e9d4ff",
    "background-color": "#faf5ff",
    "color": "#8200db"
  }
}

dedup_time = new FormControl(3600)

dedup_time_data=[
  {
    "disp":"15 minutes",
    "value":900
  },
  {
    "disp":"30 minutes",
    "value":1800
  },
  {
    "disp":"1 hour",
    "value":3600
  },
  {
    "disp":"6 hours",
    "value":21600
  },
  {
    "disp":"12 hours",
    "value":43200
  },
  {
    "disp":"24 hours",
    "value":86400
  },
  {
    "disp":"7 days",
    "value":604800
  }
]

toaster_message_alerts = {
  "success":{
    "action_success":"Action updated successfully.",
    "partial_success":"Action updated successfully. ~~updated_count alerts updated.",
    "not_eligible":"No alerts were updated. Their current status does not allow this action."
  },
  "warning":{
    "assigned_to_another_user":"The alert has been assigned to another user. The list has been refreshed."
  },
  "error":{
    "update_action":"Failed to update action"
  }
}

alertSummaryPageLength:number = 1;
  alertSummaryPageNumber:number = 1;
  alertSummaryItemPerPage = new FormControl(25);
  itemsPerpageValueList = [2,5,10,15,25,50,100]

  calcAlertPagination(){
    if(this.allRows.length){
      this.alertSummaryPageLength =  Math.ceil(this.allRows.length / this.alertSummaryItemPerPage.value);
      if(this.alertSummaryPageNumber > this.alertSummaryPageLength) {
        this.alertSummaryPageNumber = this.alertSummaryPageLength
      }  
    } else {
      this.alertSummaryPageLength = 1
    }
  }

  resetAlertPagination(){
    this.alertSummaryItemPerPage.reset(25)
  }

  actionUpdateToasterMsg(action:number,updated_rows:number,total_rows:number,bulk:boolean){
    let status = 0;
    if(action == 2 && updated_rows == 0 && !bulk){
      this.createtoastmsg({
        "type":"warning", 
        "text":this.toaster_message_alerts.warning.assigned_to_another_user
      })
      status = 1;
    } else if(updated_rows == 0){
      this.createtoastmsg({
        "type":"success", 
        "text":this.toaster_message_alerts.success.not_eligible
      })
    } else if(updated_rows < total_rows) {
      this.createtoastmsg({
        "type":"success", 
        "text":this.toaster_message_alerts.success.partial_success.replace('~~updated_count',updated_rows.toString() + " of " + total_rows.toString())
      })
    } else {
      this.createtoastmsg({
        "type":"success", 
        "text":this.toaster_message_alerts.success.action_success
      })
    }
    return status
  }

  updatingD3 = false

  alertsheetmeta: any = JSON.parse(JSON.stringify(this.sharedService.metaData.alert));

  metadata = JSON.parse(JSON.stringify(this.sharedService.metaData.alert.factsheetMeta.metadata))

  defaultValues = JSON.parse(JSON.stringify(this.sharedService.metaData.alert.alertDefaults.defaultValues))

  // moduleName="explorelogs"
  moduleName = JSON.parse(JSON.stringify(this.sharedService.metaData.alert.factsheetMeta.moduleName))

  filteredNodesumarryArray = []
  eventWorkFlowInfo = {
    paginationDataWorkFlowAlert: [],
    selectedAlerts: {},
    alertKeys_list: [],
    selectedeventspagenumber: 1,
    selectedeventspagelength: 1,
    selectedAlertsEnable: true,
    alertWorkFlowSelectAll: new FormControl(false),
    alertWorkFlowSearch: new FormControl(''),
    alertWorkFloweventsItemperpage: new FormControl(25)
  }

  closeExploreAlerts(){
    this.factSheetOpened = false;
    this.resetFactsheetPanels();
    this.alertService.provideeventsdata.refresh()
  }


  setdefaultAlertFilter(){
    this.alertTimeFilter.setValue(this.default_summary_time_filter)
    this.alertSeverityFilter.setValue(["all"])
    this.alertStateFilter.setValue(["all"])
    this.alertPlatformFilter.setValue(["all"])
    this.alertAnalystFilter.setValue(this.sharedService.getCurrentUserId())
// console.log(this.sharedService.getCurrentUserId())
  }


  setStateFilter(user_id){
    
    if(user_id == this.sharedService.getCurrentUserId()) {
        this.sharedService.state_map[0]["status"] = 1
        this.sharedService.state_map[1]["status"] = 1
        this.alertStateFilter.reset()
        this.alertStateFilter.setValue(["all"])
      } 
    else {
         this.sharedService.state_map[0]["status"] = 0
         this.sharedService.state_map[1]["status"] = 0
         this.alertStateFilter.reset()
         this.alertStateFilter.setValue(this.alert_tab_metadata.default_values.other_analyst_states)
    }
    
    
  }

  resetGlobalFilter(){
    this.alertStateFilter.reset()
    this.selectedGlobalFilters.length = 0;
  }

  checkGlobalFilterActive(){
    return this.getSeverityFilterValue().length? true:false
  }

  getSeverityFilterValue(){
    if(this.alertSeverityFilter.value){
      return this.alertSeverityFilter.value
    } else {
      return []
    }
  }
  getStateFilterValue(){
    if(this.alertStateFilter.value){
      return this.alertStateFilter.value
    } else {
      return []
    }
  }
  getPlatformFilterValue(){
    if(this.alertPlatformFilter.value){
      return this.alertPlatformFilter.value
    } else {
      return []
    }
  }

  getAnalystFilterValue(){
    if(this.alertAnalystFilter.value){
      return this.alertAnalystFilter.value
    } else {
      return []
    }
  }

  toDate(metaDate: any) {
    let date=[this.timezoneservice.toUtcTimeZonefromUser(this.calculate_timerange(metaDate)[0]).format('YYYY-MM-DD HH:mm:ss'),this.timezoneservice.toUtcTimeZonefromUser(this.calculate_timerange(metaDate)[1]).format('YYYY-MM-DD HH:mm:ss')]
    return date
  }

  buildAlertSummaryReqobj(){
    return {
      "timerange":this.toDate(this.alertTimeFilter.value),
      "severity":this.getSeverityFilterValue(),
      // "assigned_user":[this.sharedService.analystlist.find(item => item.disp === this.sharedService.userName)?.value ?? 0],
      "assigned_user": [this.getAnalystFilterValue()],
      "platform":this.getPlatformFilterValue(),
      "status":this.getStateFilterValue()

    }
  }

  formatNumber(value) {
    const abs = Math.abs(value);
  
    if (abs >= 1e33) {
      return (value / 1e33).toFixed(1).replace(/\.0$/, '') + ' Dc';
    } else if (abs >= 1e30) {
      return (value / 1e30).toFixed(1).replace(/\.0$/, '') + ' No';
    } else if (abs >= 1e27) {
      return (value / 1e27).toFixed(1).replace(/\.0$/, '') + ' Oc';
    } else if (abs >= 1e24) {
      return (value / 1e24).toFixed(1).replace(/\.0$/, '') + ' Sp';
    } else if (abs >= 1e21) {
      return (value / 1e21).toFixed(1).replace(/\.0$/, '') + ' Sx';
    } else if (abs >= 1e18) {
      return (value / 1e18).toFixed(1).replace(/\.0$/, '') + ' Qi';
    } else if (abs >= 1e15) {
      return (value / 1e15).toFixed(1).replace(/\.0$/, '') + ' Qa';
    } else if (abs >= 1e12) {
      return (value / 1e12).toFixed(1).replace(/\.0$/, '') + ' Tn';
    } else if (abs >= 1e9) {
      return (value / 1e9).toFixed(1).replace(/\.0$/, '') + ' Bn';
    } else if (abs >= 1e6) {
      return (value / 1e6).toFixed(1).replace(/\.0$/, '') + ' Mn';
    } else if (abs >= 1e3) {
      return (value / 1e3).toFixed(1).replace(/\.0$/, '') + ' K';
    }
  
    return value;
  }

  phoneError = {
    "required": "*Phone number is mandatory",
    "numberError": "Invalid phone number"
  }
  emailError = {
    "required": "*Email Id is mandatory",
    "emailError": "Invalid mail Id"
  }
  messageError = {
    "required": "message can't be empty"
  }


  phoneNumberValidation(): ValidatorFn {
    return (control: AbstractControl) => {
      const regex = /^[6-9]\d{9}$/;
      if (!control.value) return null;
      return regex.test(control.value) ? null : { numberError: true };
    };
  }

  emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) return null;

      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      const valid = regex.test(control.value);

      return valid ? null : { emailError: true };
    };
  }



  communicationMethods = [
    {
      "disp": "Phone",
      "value": "phone"
    },
    {
      "disp": "E-mail",
      "value": "email"
    }
  ]

  retroPeriodData = [
    {
      "disp": "1 Hour",
      "value": 3600
    },
    {
      "disp": "2 Hours",
      "value": 7200
    },
    {
      "disp": "6 Hours",
      "value": 21600
    },
    {
      "disp": "1 Day",
      "value": 86400
    },
    {
      "disp": "2 Days",
      "value": 172800
    }
  ]

  validForType = [
    {
      "disp": "For",
      "value": "for",
      "status": 0
    },
    {
      "disp": "Till",
      "value": "till",
      "status": 1
    }
  ]

  validForData = [
    {
      "disp": "1 Day",
      "value": 86400
    },
    {
      "disp": "2 Days",
      "value": 172800
    },
    {
      "disp": "5 Days",
      "value": 432000
    },
    {
      "disp": "10 Days",
      "value": 864000
    }
  ]

  ruleselectedIndex = 0

  defaultAutoClosureRuleCondition = {
    "conditions": [
      {
        "actions": {
          "query": "",
          "state": null,
          "action": null,
          "reason": null,
          "tokens": {
          },
          "category": null,
          "comments": "",
          "condition": "if",
          "isValid": false,
          "communications": {
            "method": "phone",
            "phone": {
              "country_code": "+91",
              "number": null,
              "message": null
            },
            "email": {
              "mail_id": null,
              "subject": null,
              "mail_body": null
            }
          }
        }
      }
    ]
  }

  autoClosureRuleCondition = {
    "conditions": [
      {
        "actions": {
          "query": "",
          "state": null,
          "action": null,
          "reason": null,
          "tokens": {
          },
          "category": null,
          "comments": "",
          "condition": "if",
          "isValid": false,
          "communications": {
            "method": "phone",
            "phone": {
              "country_code": "+91",
              "number": null,
              "message": null
            },
            "email": {
              "mail_id": null,
              "subject": null,
              "mail_body": null
            }
          }
        }
      }
    ]
  }

  defaultRuleCOnditions = {
    "name": "TI Match - Inbound",
    "type": "auto_investigate",
    "ruleId": "AIV.0001.03",
    "status": 1,
    "ruleFor": "FWFGT.0014.05",
    "platform": "firewall_fortigate",
    "stepsize": 86400,
    "timeframe": 86400,
    "status_change": false,
    "conditions": [
      {
        "actions": {
          "query": "",
          "state": null,
          "action": null,
          "reason": null,
          "tokens": {
          },
          "category": null,
          "comments": "",
          "condition": "if",
          "isValid": false,
          "communications": {
            "method": "phone",
            "phone": {
              "country_code": "+91",
              "number": null,
              "message": null
            },
            "email": {
              "mail_id": null,
              "subject": null,
              "mail_body": null
            }
          }
        }
      },
      {
        "actions": {
          "query": "",
          "state": null,
          "action": null,
          "reason": null,
          "category": null,
          "tokens": {
            "SearchCommand": []
          },
          "comments": "",
          "platform": "firewall_fortigate",
          "condition": "else",
          "isValid": true,
          "communications": {
            "method": "phone",
            "phone": {
              "country_code": "+91",
              "number": null,
              "message": null
            },
            "email": {
              "mail_id": null,
              "subject": null,
              "mail_body": null
            }
          }
        }
      }
    ],
    "description": "",
    "retroactive": false,
    "activate_rule": true
  }

  ruleCOnditions = {
    "name": "TI Match - Inbound",
    "type": "auto_investigate",
    "ruleId": "AIV.0001.03",
    "status": 1,
    "ruleFor": "FWFGT.0014.05",
    "platform": "firewall_fortigate",
    "stepsize": 86400,
    "timeframe": 86400,
    "status_change": false,
    "conditions": [
      {
        "actions": {
          "query": "",
          "state": null,
          "action": null,
          "reason": null,
          "tokens": {
          },
          "category": null,
          "comments": "",
          "condition": "if",
          "isValid": false,
          "communications": {
            "method": "phone",
            "phone": {
              "country_code": "+91",
              "number": null,
              "message": null
            },
            "email": {
              "mail_id": null,
              "subject": null,
              "mail_body": null
            }
          }
        }
      },
      {
        "actions": {
          "query": "",
          "state": null,
          "action": null,
          "reason": null,
          "category": null,
          "tokens": {
            "SearchCommand": []
          },
          "comments": "",
          "platform": "firewall_fortigate",
          "condition": "else",
          "isValid": true,
          "communications": {
            "method": "phone",
            "phone": {
              "country_code": "+91",
              "number": null,
              "message": null
            },
            "email": {
              "mail_id": null,
              "subject": null,
              "mail_body": null
            }
          }
        }
      }
    ],
    "description": "",
    "retroactive": false,
    "activate_rule": true
  }

  timeError: boolean = false
  listFieldError: boolean = false

  timeframe = [
    {
      "disp": "10 Minutes",
      "value": 600,
      "range": [{ "min": 600, "max": 600 }]
    },
    {
      "disp": "20 Minutes",
      "value": 1200,
      "range": [{ "min": 600, "max": 1200 }]
    },
    {
      "disp": "30 Minutes",
      "value": 1800,
      "range": [{ "min": 600, "max": 1800 }]
    },
    {
      "disp": "1 Hour",
      "value": 3600,
      "range": [{ "min": 600, "max": 3600 }]
    },
    {
      "disp": "2 Hours",
      "value": 7200,
      "range": [{ "min": 3600, "max": 7200 }]
    },
    {
      "disp": "6 Hours",
      "value": 21600,
      "range": [{ "min": 3600, "max": 21600 }]
    },
    {
      "disp": "12 Hours",
      "value": 43200,
      "range": [{ "min": 3600, "max": 43200 }]
    },
    {
      "disp": "1 Day",
      "value": 86400,
      "range": [{ "min": 3600, "max": 86400 }]
    },
    {
      "disp": "2 Days",
      "value": 172800,
      "range": [{ "min": 86400, "max": 172800 }]
    },
    {
      "disp": "7 Days",
      "value": 604800,
      "range": [{ "min": 86400, "max": 604800 }]
    },
  ]

  platform_fields = this.sharedService.commonPlatformFields

  consolidationfields = []

  convertPlatformFields() { // convert common fields to ['disp','value,] structure
    //console.log("Platform Fields----->",this.platform_fields)
    Object.keys(this.platform_fields).forEach(key => {

      if (this.platform_fields[key].is_entity === 1) {
        // console.log("Platform Fields (Entity Check)----->",this.platform_fields[key])
        this.consolidationfields.push(this.platform_fields[key])
      }

    })
  }

  resetConsolidation() { // reset consolidation form control
    this.consolidation.patchValue({
      context: ({
        description: '',
        activate: '',
        retroactive: ''
      }),
      conditions: ({
        fields: '',
        timeframe: ''
      })
    })
  }

  convertFieldsToPost() {
    //console.log(this.consolidation.value.conditions.fields)
    let check = []
    Object.keys(this.consolidation.value.conditions.fields).forEach(val => {
      let index = this.platform_fields.findIndex(item => item.value === this.consolidation.value.conditions.fields[val]);
      // console.log(this.platform_fields[index])
      check.push(this.platform_fields[index])
    })
    return check
  }

  consolidationError = { "field_error": "Fields can't be empty", "time_error": "Time Frame can't be empty" }

  consolidationTime = [
    {
      "disp": "Hourly",
      "value": "hourly"
    },
    {
      "disp": "Daily",
      "value": "daily"
    },
    {
      "disp": "Monthly",
      "value": "monthly"
    }
  ]

  // consolidationfields=[
  //   {
  //     "disp":"Hourly",
  //     "value":"hourly"
  //   },
  //   {
  //     "disp":"Daily",
  //     "value":"daily"
  //   },
  //   {
  //     "disp":"Monthly",
  //     "value":"monthly"
  //   }
  // ]

  stepsize = [
    {
      "disp": "10 Minutes",
      "value": 600
    },
    {
      "disp": "20 Minutes",
      "value": 1200
    },
    {
      "disp": "30 Minutes",
      "value": 1800
    },
    {
      "disp": "1 Hour",
      "value": 3600
    }
  ]

  stepsize1 = [
    {
      "disp": "10 Minutes",
      "value": 600
    },
    {
      "disp": "20 Minutes",
      "value": 1200
    },
    {
      "disp": "30 Minutes",
      "value": 1800
    },
    {
      "disp": "1 Hour",
      "value": 3600
    },
    {
      "disp": "2 Hours",
      "value": 7200
    },
    {
      "disp": "6 Hours",
      "value": 21600
    },
    {
      "disp": "12 Hours",
      "value": 43200
    },
    {
      "disp": "1 Day",
      "value": 86400
    },
    {
      "disp": "2 Days",
      "value": 172800
    },
    {
      "disp": "7 Days",
      "value": 604800
    },
  ]

  AlertEventsCount: any = 0;


  SelectAllAlerts = false
  // metadata={
  //   "errors":{"query_error":"*Query is not verified","action_error":"*Closure Action is empty"},
  //   "ruleTypes":[
  //     {
  //       "disp":"Consolidation Rule",
  //       "value":"consolidation"
  //     },
  //     {
  //       "disp":"Auto Closure Rule",
  //       "value":"auto_closure"
  //     },
  //     {
  //       "disp":"Auto Investigate Rule",
  //       "value":"auto_investigate"
  //     },
  //     {
  //       "disp":"Complex Rule",
  //       "value":"complex"
  //     }
  //   ],
  //   "alertFilterTitles":{
  //     "time":"TIME",
  //     "platform":"PLATFORM",
  //     "severity":"SEVERITY",
  //     "title":"TITLE",
  //     "data_type":"DATA TYPE",
  //     "observable":"OBSERVABLE",
  //     "signature":"SIGNATURE",
  //     "tags":"TAGS"
  //   },
  //   "alertInfoTitles":{"status":"STATUS"},
  //   "ruleTitles":{
  //     "rule_details":"Rule Details : ",
  //     "rule_name":"Rule Name",
  //     "activate_rule":"Activate Rule : ",
  //     "run_retroactively":"Run Retroactively : ",
  //     "define_rule_condition":"Define Rule Condition : ",
  //     "run_tests":"Run Tests > ",
  //     "alert_test_volume":"Alert Test Volume",
  //     "auto_actionable_alerts":"Auto Actionable Alerts",
  //     "effective_noise_reduction":"Effective Noise Reduction",
  //     "alerts":"Alerts",
  //     "percent":"%",
  //     "closure_action":"Closure Action",
  //     "comments":"Comments:",
  //     "auto_rule":"Auto Action rule for ",
  //     "description":"Description",
  //     "cancel":"Cancel",
  //     "save":"Save",
  //     "if":"IF",
  //     "else":"ELSE",
  //     "else_if":"ELSE IF",
  //     "choose_tags":"Choose Tags",
  //     "yes":"Yes",
  //     "no":"No"
  //   },
  //   "description":{
  //     "auto_closure":"The Auto Closure rule enables a rule condition to be defined based on which the alert will be auto actioned",
  //     "auto_investigate":"Auto Investigate rule enables a rule condition to be defined based on which the alert will be auto actioned"
  //   }
  // }


  // defaultValues={
  //   "autoInvestigateConditioLimit":5,
  //   "elseDefault":{"actions":{
  //       "query": "",
  //       "state": "",
  //       "action": "",
  //       "reason": "",
  //       "add_tags": {
  //           "tags": {}
  //       },
  //       "comments": "",
  //       "platform": "firewall_fortigate",
  //       "condition": "else",
  //       "engineQuery": {
  //           "searchtokens": []
  //       }
  //     }
  //   },
  //     "elseIfDefault":{"actions":{
  //       "query": "",
  //       "state": "",
  //       "action": "",
  //       "reason": "",
  //       "add_tags": {
  //           "tags": {}
  //       },
  //       "comments": "",
  //       "platform": "firewall_fortigate",
  //       "condition": "else_if",
  //       "engineQuery": {
  //           "searchtokens": []
  //       }
  //     }
  //   },
  //   "chipsDefault":[
  //       {
  //           "time": {
  //             "disp": "Today",
  //             "value": [
  //                 0,
  //                 "today",
  //                 0
  //             ],
  //             "count": null,
  //             "mandatory":true
  //         },
  //       },
  //       {
  //           "platform": {
  //               "disp": "Fortigate Firewall",
  //               "value": "firewall_fortigate",
  //               "count": 0,
  //               "mandatory":true
  //           }
  //       }
  //     ],
  //     "closureAction":{
  //       "notification": {
  //         "disp": "Send Notifications",
  //         "enable": false,
  //         "state": 0,
  //         "mailid": "",
  //         "phone": null
  //       },
  //       "execute_cmd": {
  //         "disp": "Execute Command",
  //         "enable": false,
  //         "state": 0,
  //         "cmd": ""
  //       },
  //       "add_tags": {
  //         "disp": "Add Tags",
  //         "enable": true,
  //         "state": 0,
  //         "tags": [
  //           {}
  //         ]
  //       },
  //       "run_tasks": {
  //         "disp": "Run Tasks",
  //         "enable": false,
  //         "state": 0,
  //         "task": ""
  //       },
  //       "no_action_required":{
  //         "disp":"No Action Required",
  //         "enable":true,
  //         "state":1
  //       }
  //     }
  // }

  status_change: boolean = false

  auto_investigate_limit = JSON.parse(JSON.stringify(this.defaultValues.autoInvestigateConditioLimit))

  no_of_alerts: number

  // defaultElse=JSON.parse(JSON.stringify(this.defaultValues.elseDefault))

  defaultElse = {
    "actions": {
      "query": "",
      "state": "",
      "action": "",
      "reason": "",
      "add_tags": {
        "tags": {}
      },
      "comments": "",
      "platform": "firewall_fortigate",
      "condition": "else",
      "tokens": {
        "SearchCommand": []
      }
    }
  }

  // defaultElseIf=JSON.parse(JSON.stringify(this.defaultValues.elseIfDefault))

  defaultElseIf = {
    "actions": {
      "query": "",
      "state": "",
      "action": "",
      "reason": "",
      "add_tags": {
        "tags": {}
      },
      "comments": "",
      "platform": "firewall_fortigate",
      "condition": "else_if",
      "tokens": {
        "SearchCommand": []
      }
    }
  }






  testResultVolume: any;
  queryVerified: boolean = false
  postError: boolean = true
  showError: boolean = false
  actionEmpty: boolean = true
  showActionError: boolean = false
  ActionErrorText: string = ''
  // errorTypes={"query_error":"*Query is not verified","action_error":"*Closure Action is empty"}
  errorTypes = JSON.parse(JSON.stringify(this.metadata.errors))

  actionWindow: string = "no_action_required"
  stateWindow: string;


  editState: boolean = false
  editrequested = {
    state: false,
    value: null
  }


  // editState:boolean=true

  // editrequested = {
  //   state:true,
  //   value:{
  //     "conditions": [
  //         {
  //             "actions": {
  //                 "action": "flagged_for_review",
  //                 "state": "True positive",
  //                 "reason": "Malware Infection",
  //                 "comments": "if comments",
  //                 "add_tags": {
  //                     "tags": {
  //                         "killchain": {},
  //                         "compliance": {},
  //                         "mitreattack": {},
  //                         "threatgroup": {}
  //                     }
  //                 },
  //                 "query": "action=\"value\"",
  //                 "engineQuery": {
  //                     "searchtokens": [
  //                         {
  //                             "cat": "field",
  //                             "type": "text",
  //                             "image": "action"
  //                         },
  //                         {
  //                             "cat": "operator",
  //                             "type": "",
  //                             "image": "="
  //                         },
  //                         {
  //                             "cat": "value",
  //                             "type": "text",
  //                             "image": "value"
  //                         }
  //                     ]
  //                 },
  //                 "condition": "if"
  //             }
  //         },
  //         {
  //             "actions": {
  //                 "action": "close",
  //                 "state": "Benign true positive",
  //                 "reason": "Red Team",
  //                 "add_tags": {
  //                     "tags": {
  //                         "killchain": {},
  //                         "compliance": {},
  //                         "mitreattack": {},
  //                         "threatgroup": {}
  //                     }
  //                 },
  //                 "query": "app=\"deny\"",
  //                 "engineQuery": {
  //                     "searchtokens": [
  //                         {
  //                             "cat": "field",
  //                             "type": "text",
  //                             "image": "app"
  //                         },
  //                         {
  //                             "cat": "operator",
  //                             "type": "",
  //                             "image": "="
  //                         },
  //                         {
  //                             "cat": "value",
  //                             "type": "text",
  //                             "image": "deny"
  //                         }
  //                     ]
  //                 },
  //                 "condition": "else_if"
  //             }
  //         },
  //         {
  //             "actions": {
  //                 "action": "close",
  //                 "state": "Undetermined",
  //                 "reason": "Duplicate",
  //                 "add_tags": {
  //                     "tags": {
  //                         "killchain": {},
  //                         "compliance": {},
  //                         "mitreattack": {},
  //                         "threatgroup": {}
  //                     }
  //                 },
  //                 "query": "applist=\"accept\"",
  //                 "engineQuery": {
  //                     "searchtokens": [
  //                         {
  //                             "cat": "field",
  //                             "type": "text",
  //                             "image": "applist"
  //                         },
  //                         {
  //                             "cat": "operator",
  //                             "type": "",
  //                             "image": "="
  //                         },
  //                         {
  //                             "cat": "value",
  //                             "type": "text",
  //                             "image": "accept"
  //                         }
  //                     ]
  //                 },
  //                 "condition": "else"
  //             }
  //         }
  //     ],
  //     "ruleFor": "A0004009",
  //     "description": "",
  //     "platform": "firewall_fortigate",
  //     "type": "auto_investigate",
  //     "name": "ICMP Traffic with Significant Data Transfer to External IPs\t",
  //     "status": 1,
  //     "enginechange": false
  // }
  // };

  // queryValidator(control: AbstractControl): ValidationErrors | null {
  //   let value = control.value.query;
  //   let valid = this.queryEditorService.isEditorError(this.ruleConditionEditor)
  //   return valid ? { 'queryValid': true } : null;
  // }

  defaultActions = {
    action: null,
    state: null,
    reason: null,
    comments: null,
    // tags: Array.from(this.alertvarservice.tagsSet || []),
    add_tags: {
      tags: null,
    },
    // actionWindow: this.actionWindow,
    // stateWindow: this.stateWindow,
    query: null,
    engineQuery: null
  }

  queryValidator = (control: AbstractControl): ValidationErrors | null => {
    // let value = control.value.query;
    let hasError = false
    if (this.ruleConditionEditor) {
      // this.queryEditorService.set_editor_value(this.ruleConditionEditor,value)
      if (control.value) {
        hasError = this.queryEditorService.isEditorError(this.ruleConditionEditor);
        return hasError ? { queryValid: false } : null;
      }
    }
    else {
      return hasError ? { queryValid: true } : null;
    }
  };


  autoInvestigate = new FormGroup({
    conditions: new FormArray([
      new FormGroup({
        actions: new FormControl(this.defaultActions, [this.queryValidator])
      }),
      new FormGroup({
        actions: new FormControl()
      })
    ])
  })

  defaultAutoInvestigate = new FormGroup({
    conditions: new FormArray([
      new FormGroup({
        actions: new FormControl()
      }),
      new FormGroup({
        actions: new FormControl()
      })
    ])
  })

  resetAutoInvestigate() {
    //console.log("After Reset --->",this.autoInvestigate)
    // for (let i=0;i<this.autoInvestigate.value.conditions.length;i++){
    //   if(i!=0 && i!=1){
    //     console.log("reset delete-->",i)
    //     this.autoInvestigate.controls.conditions.removeAt(i)
    //   }
    //   else{
    //     this.autoInvestigate.controls.conditions[i]?.actions.setValue('')
    //     console.log("reset setvalue-->",i)
    //   }
    for (let i = this.autoInvestigate.value.conditions.length - 1; i >= 2; i--) {
      this.autoInvestigate.controls.conditions.removeAt(i);
    }
    for (let i = 0; i < this.autoInvestigate.value.conditions.length; i++) {
      this.autoInvestigate.controls.conditions.controls[i].controls.actions.setValue(null)

      //console.log("reset setvalue-->",i)
    }
    // }
    // this.autoInvestigate.controls.conditions.clear()
    // this.addNewCond()
    //console.log("After Reset 1 --->",this.autoInvestigate)
    // this.queryEditorService.set_editor_value(this.ruleConditionEditor,null)
    // this.autoInvestigate.patchValue({
    //   conditions:null
    // })
    // this.autoInvestigate=this.defaultAutoInvestigate
    //console.log("After Reset 2 --->",this.autoInvestigate)
  }

  resetAutoClosure() {

    for (let i = this.autoInvestigate.value.conditions.length - 1; i >= 1; i--) {
      this.autoInvestigate.controls.conditions.removeAt(i);
    }
    for (let i = 0; i < this.autoInvestigate.value.conditions.length; i++) {
      this.autoInvestigate.controls.conditions.controls[i].controls.actions.setValue(null)
    }
  }

  addNewCond() {
    return new FormGroup({
      actions: new FormControl()
    })
  }

  autoInvList = [
    {
      "cond": "if",
      "index": 1,
      "optional": false,
      "value": {}
    },
    {
      "cond": "else",
      "index": 2,
      "optional": true,
      "value": {}
    }
  ]

  payload: any = {
    "timerange": [],
    "platform": "firewall_fortigate",
    "tags": {
      "killchain": [],
      "compliance": [],
      "mitreattack": [],
      "threatgroup": []
    },
    "severity": [],
    "status": [],
    "title": [],
    "data_type": [],
    "observable": [],
    "signature": []
  }


  // ruleTypes = JSON.parse(JSON.stringify(this.metadata.ruleTypes))
  ruleTypes=[
    {
      "disp":"Consolidation rule",
      "value":"consolidation"
    },
    {
      "disp":"Auto closure rule",
      "value":"auto_closure"
    },
    {
      "disp":"Auto investigate rule",
      "value":"auto_investigate"
    },
    {
      "disp":"Complex rule",
      "value":"complex"
    },
    {
      "disp":"Direct to signal",
      "value":"direct_to_signal"
    },
  ];

  ruleName;

  mockalert = {
    "token": "319fc223",
    "isData": true,
    "res_obj": {
      "alertRows": [
        {
          "alertId": "A0004009",
          "platform": "firewall_fortigate",
          "severity": "high",
          "alertTitle": "ICMP Traffic with Significant Data Transfer to External IPs\t",
          "created_dt": "2025-05-12T13:03:21.399722"
        },
        {
          "alertId": "A0004011",
          "platform": "firewall_fortigate",
          "severity": "high",
          "alertTitle": "Outbound SMB Traffic to External IPs",
          "created_dt": "2025-05-13T05:02:56.988598",
          "hosts": [
            "traffic"
          ],
          "hostsCount": 1,
          "alertCount": 449151,
          "lastAlertTime": 1757491800
        },
        {
          "alertId": "A0004013",
          "platform": "firewall_fortigate",
          "severity": "high",
          "alertTitle": "Outbound Traffic to ports associated with cleartext and legacy protocols",
          "created_dt": "2025-05-13T06:14:26.186061"
        },
        {
          "alertId": "A0004014",
          "platform": "firewall_fortigate",
          "severity": "high",
          "alertTitle": "Unauthorized Remote Desktop (RDP) Traffic",
          "created_dt": "2025-05-13T06:27:55.112264",
          "hosts": [
            "traffic"
          ],
          "hostsCount": 1,
          "alertCount": 181493,
          "lastAlertTime": 1757491800
        },
        {
          "alertId": "A0004015",
          "platform": "firewall_fortigate",
          "severity": "medium",
          "alertTitle": "High Volume Outbound Data Transfer",
          "created_dt": "2025-05-13T06:37:52.422706"
        },
        {
          "alertId": "A0004010",
          "platform": "firewall_fortigate",
          "severity": "high",
          "alertTitle": "Outbound LDAP Traffic to External IPs",
          "created_dt": "2025-05-13T05:00:17.03796"
        },
        {
          "alertId": "A0004012",
          "platform": "firewall_fortigate",
          "severity": "high",
          "alertTitle": "Application-Layer Protocol Traffic Over Non-Standard Ports",
          "created_dt": "2025-05-13T06:07:08.438797"
        },
        {
          "alertId": "A0004016",
          "platform": "firewall_fortigate",
          "severity": "medium",
          "alertTitle": "External Port Scanning",
          "created_dt": "2025-05-13T06:41:54.603532"
        },
        {
          "alertId": "A0004017",
          "platform": "firewall_fortigate",
          "severity": "medium",
          "alertTitle": "Inbound Traffic to High-Risk Internal Services from External IPs",
          "created_dt": "2025-05-13T06:51:39.858036"
        },
        {
          "alertId": "A0004008",
          "platform": "firewall_fortigate",
          "severity": "medium",
          "alertTitle": "Outbound SSH Connections to External IPs from Internal IPs\t",
          "created_dt": "2025-05-12T12:59:18.907188",
          "hosts": [
            "traffic"
          ],
          "hostsCount": 1,
          "alertCount": 520,
          "lastAlertTime": 1757491800
        },
        {
          "alertId": "A0004002",
          "platform": "firewall_fortigate",
          "severity": "high",
          "alertTitle": "Cleartext Protocol Usage Traffic by Internal IPs",
          "created_dt": "2025-05-12T10:17:08.812001",
          "hosts": [
            "traffic"
          ],
          "hostsCount": 1,
          "alertCount": 1201504,
          "lastAlertTime": 1757491800
        },
        {
          "alertId": "A0004003",
          "platform": "firewall_fortigate",
          "severity": "high",
          "alertTitle": "Inbound Traffic  to Risky Ports\t",
          "created_dt": "2025-05-12T10:21:26.500417",
          "hosts": [
            "traffic"
          ],
          "hostsCount": 1,
          "alertCount": 181493,
          "lastAlertTime": 1757491800
        },
        {
          "alertId": "A0004004",
          "platform": "firewall_fortigate",
          "severity": "high",
          "alertTitle": "Hiigh number of connections from internal IPs to one external IP\t",
          "created_dt": "2025-05-12T10:23:39.158168"
        },
        {
          "alertId": "A0004005",
          "platform": "firewall_fortigate",
          "severity": "high",
          "alertTitle": "Outbound FTP Traffic to External IPs\t",
          "created_dt": "2025-05-12T10:24:50.439944"
        },
        {
          "alertId": "A0004006",
          "platform": "firewall_fortigate",
          "severity": "medium",
          "alertTitle": "Outbound Traffic from Internal IPs on Nonstandard Ports\t",
          "created_dt": "2025-05-12T10:25:45.79032",
          "hosts": [
            "traffic"
          ],
          "hostsCount": 1,
          "alertCount": 3674623,
          "lastAlertTime": 1757491800
        },
        {
          "alertId": "A0004007",
          "platform": "firewall_fortigate",
          "severity": "medium",
          "alertTitle": "Suspicious SSH Activity Outside Business Hours",
          "created_dt": "2025-05-12T12:54:34.892432",
          "hosts": [
            "traffic"
          ],
          "hostsCount": 1,
          "alertCount": 82346,
          "lastAlertTime": 1757491800
        },
        {
          "alertId": "A0004001",
          "platform": "firewall_fortigate",
          "severity": "high",
          "alertTitle": "Outbound Network Connection to High-Risk Countries\t",
          "created_dt": "2025-05-12T09:58:00.169779",
          "hosts": [
            "traffic"
          ],
          "hostsCount": 1,
          "alertCount": 980,
          "lastAlertTime": 1757484000
        }
      ],
      "totalAlertCount": 5772110
    }
  }

  getAlertData(): Observable<any> {
    return of(this.mockalert); // returning as Observable
  }


  public _ruleType = new BehaviorSubject<string | null>(null);
  public $ruleGroup = this._ruleType.asObservable();

  setRuleType(value: string) {
    this._ruleType.next(value);
  }

  public _alertName = new BehaviorSubject<string | null>(null);
  public $alertName = this._alertName.asObservable();

  setAlertTitle(value: any) {
    this._alertName.next(value);
  }

  public _platform = new BehaviorSubject<string | null>(null);
  public $platform = this._platform.asObservable();

  setPlatform(value: any) {
    this._platform.next(value);
  }

  public _alert = new BehaviorSubject<string | null>(null);
  public $alert = this._alert.asObservable();

  setAlert(value: any) {
    this._alert.next(value);
  }

  process_state: boolean = false

  // alertFilterTitles=JSON.parse(JSON.stringify(this.metadata.alertFilterTitles))
  alertFilterTitles = { "time": "TIME", "platform": "PLATFORM", "severity": "SEVERITY", "title": "ALERT NAME", "data_type": "DATA TYPE", "observable": "OBSERVABLE", "signature": "SIGNATURE", "tags": "TAGS" }

  alertInfoTitles = JSON.parse(JSON.stringify(this.metadata.alertInfoTitles))
  //  alertInfoTitles={"status":"STATUS"}

  runTestTableHeaders = ['METRICS','VALUES']

  // ruleTitles = JSON.parse(JSON.stringify(this.metadata.ruleTitles))

  titles={
    "ruleTitles": {
      "activate_rule": "Activate Rule : ",
      "alert_test_volume": "Alert Test Volume",
      "alerts": "Alerts",
      "auto_actionable_alerts": "Auto Actionable Alerts",
      "auto_rule": "Auto Action rule for ",
      "cancel": "Cancel",
      "choose_tags": "Choose Tags",
      "closure_action": "Closure Action",
      "comments": "Comments:",
      "define_rule_condition": "Define Rule Condition : ",
      "description": "Description",
      "effective_noise_reduction": "Effective Noise Reduction",
      "else": "ELSE",
      "else_if": "ELSE IF",
      "if": "IF",
      "no": "No",
      "percent": "%",
      "rule_details": "Rule Details : ",
      "rule_name": "Rule Name",
      "run_retroactively": "Run Retroactively : ",
      "run_tests": "Run Test ",
      "save": "Save",
      "yes": "Yes",
      "valid": "Valid",
      "next": "Next",
      "configuration": "Configuration",
      "previous": "Previous",
      "verify_query": "Verify query",
      "arrow": ">",
      "send_communications": "Send Communications",
      "optional": "(Optional)",
      "phone_number": "Phone number:",
      "message": "Message:",
      "email_id": "Email id:",
      "subject": "Subject:",
      "mail_content": "Mail content:",
      "time_frame": "TimeFrame",
      "step_size": "StepSize",
      "auto_closure_rule_for": "Auto closure rule for",
      "auto_investigate_rule_for": "Auto investigate rule for",
      "direct_signal_for": "Direct to signal for"
    },
    "factSheetTitles": {
      "aggregation_condition": "Aggregation Condition",
      "events": "Events",
      "go": "GO",
      "cancel": "Cancel",
      "rule_details": "Rule details",
      "entity": "Entity:",
      "none": "None",
      "selected": "Selected",
      "no_result_found": "No result found",
      "filters_applied": "Filters applied",
      "no_filters_applied": "No filters applied",
      "finish": "Finish"
    },
    "relationChartTitles": {
      "cancel": "CANCEL",
      "choose_target_entity": "Choose Target Entity",
      "no_relations": "No relations",
      "instant_filter": "Instant Filter",
      "remove": "Remove"
    },
    "summaryTableTitles": {
      "clear": "CLEAR",
      "filter": "Filter",
      "none": "None"
    },
    "templateTitles": {
      "add_notes": {
        "add_notes": "Add notes",
        "no_result": "No result",
        "cancel": "CANCEL",
        "submit": "SUBMIT"
      },
      "additional_events": {
        "additional_events": "Additional Events",
        "event_time": "Event Time",
        "event_details": "Event Details"
      },
      "advance_filter": {
        "relative_time": "Relative Time",
        "custom_time_range": "Custom Time Range",
        "start_time": "Start time",
        "end_time": "End time",
        "episode_size": "Episode Size",
        "interval": "Interval",
        "apply": "APPLY",
        "cancel": "CANCEL"
      },
      "assign_user": {
        "users": "Users",
        "select_one_error": "*Select atleast one user",
        "no_result": "No result",
        "submit": "SUBMIT",
        "cancel": "CANCEL"
      },
      "force_continue": {
        "user": "User",
        "last_reviewed_at": "last reviewed at",
        "yes": "Yes",
        "no": "No"
      },
      "update_action": {
        "action": "Action",
        "assign_to": "Assign to:",
        "comments": "Comments:",
        "cancel": "CANCEL",
        "submit": "SUBMIT"
      }
    },
    "ticketingTitles": {
      "from": "FROM",
      "to": "To",
      "apply": "Apply"
    },
    "alertTitles": {
      "no_result": "No result found"
    }
  }

   ruleTitles={
    "activate_rule": "Activate Rule : ",
    "alert_test_volume": "Alert Test Volume",
    "alerts": "Alerts",
    "auto_actionable_alerts": "Auto Actionable Alerts",
    "auto_rule": "Auto Action rule for ",
    "cancel": "Cancel",
    "choose_tags": "Choose Tags",
    "closure_action": "Closure Action",
    "comments": "Comments:",
    "define_rule_condition": "Define Rule Condition : ",
    "description": "Description",
    "effective_noise_reduction": "Effective Noise Reduction",
    "else": "ELSE",
    "else_if": "ELSE IF",
    "if": "IF",
    "no": "No",
    "percent": "%",
    "rule_details": "Rule Details : ",
    "rule_name": "Rule Name",
    "run_retroactively": "Run Retroactively : ",
    "run_tests": "Run Test ",
    "save": "Save",
    "yes": "Yes",
    "valid":"Valid",
    "next":"Next",
    "configuration":"Configuration",
    "previous":"Previous",
    "verify_query":"Verify query",
    "arrow":">",
    "send_communications":"Send Communications",
    "optional":"(Optional)",
    "phone_number":"Phone number:",
    "message":"Message:",
    "email_id":"Email id:",
    "subject":"Subject:",
    "mail_content":"Mail content:",
    "time_frame":"TimeFrame",
    "step_size":"StepSize",
    "auto_closure_rule_for":"Auto closure rule for",
    "auto_investigate_rule_for":"Auto investigate rule for",
    "direct_signal_for":"Direct to signal for"
}

  factSheetTitles={
    "aggregation_condition":"Aggregation Condition",
    "events":"Events",
    "go":"GO",
    "cancel":"Cancel",
    "rule_details":"Rule details",
    "entity":"Entity:",
    "none":"None",
    "selected":"Selected",
    "no_result_found":"No result found",
    "filters_applied":"Filters applied",
    "no_filters_applied":"No filters applied",
    "finish":"Finish",
  }

  relationChartTitles={
    "cancel":"CANCEL",
    "choose_target_entity":"Choose Target Entity",
    "no_relations":"No relations",
    "instant_filter":"Instant Filter",
    "remove":"Remove",
  }

  summaryTableTitles={
    "clear":"CLEAR",
    "filter":"Filter",
    "none":"None"
  }

  templateTitles={
    "add_notes":{
      "add_notes":"Add notes",
      "no_result":"No result",
      "cancel":"CANCEL",
      "submit":"SUBMIT"
    },
    "additional_events":{
      "additional_events":"Additional Events",
      "event_time":"Event Time",
      "event_details":"Event Details"
    },
    "advance_filter":{
      "relative_time":"Relative Time",
      "custom_time_range":"Custom Time Range",
      "start_time":"Start time",
      "end_time":"End time",
      "episode_size":"Episode Size",
      "interval":"Interval",
      "apply":"APPLY",
      "cancel":"CANCEL"
    },
    "assign_user":{
      "users":"Users",
      "select_one_error":"*Select atleast one user",
      "no_result":"No result",
      "submit":"SUBMIT",
      "cancel":"CANCEL"
    },
    "force_continue":{
      "user":"User",
      "last_reviewed_at":"last reviewed at",
      "yes":"Yes",
      "no":"No"
    },
    "update_action":{
      "action":"Action",
      "assign_to":"Assign to:",
      "comments":"Comments:",
      "cancel":"CANCEL",
      "submit":"SUBMIT"
    }
  }

  ticketingTitles={
    "from":"FROM",
    "to":"To",
    "apply":"Apply"
  }

  alertTitles={
    "no_result":"No result found"
  }


  testResults = { "volume": 100000, "actionable": 7467, "noise": 99 }


  //  toggle={"yes":"Yes","no":"No"}

  chips = JSON.parse(JSON.stringify(this.defaultValues.chipsDefault))
  //  defaultChips=JSON.parse(JSON.stringify(this.defaultValues.chipsDefault))

  //  chips:{ [key: string]: any }[] = [
  //   {
  //       "time": {
  //         "disp": "Today",
  //         "value": [
  //             0,
  //             "today",
  //             0
  //         ],
  //         "count": null,
  //         "mandatory":true
  //     },
  //   },
  //   {
  //       "platform": {
  //           "disp": "Fortigate Firewall",
  //           "value": "firewall_fortigate",
  //           "count": 0,
  //           "mandatory":true
  //       }
  //   }
  // ];
  // defaultChips=JSON.parse(JSON.stringify(this.defaultValues.chipsDefault))
  defaultChips: { [key: string]: any }[] = [
    {
      "time": {
        "disp": "Today",
        "value": [
          0,
          "today",
          0
        ],
        "count": null,
        "mandatory": true
      },
    },
    {
      "platform": {
        "disp": "Fortigate Firewall",
        "value": "firewall_fortigate",
        "count": 0,
        "mandatory": true
      }
    }
  ];

  // description=JSON.parse(JSON.stringify(this.metadata.description))
  description = {
    "auto_closure": "The Auto Closure rule enables a rule condition to be defined based on which the alert will be auto actioned",
    "auto_investigate": "Auto Investigate rule enables a rule condition to be defined based on which the alert will be auto actioned",
    "consolidation": "The Consolidation rule allows similar alerts to be grouped together based on values in the signature fields defined"
  }




  //  closureAction=JSON.parse(JSON.stringify(this.defaultValues.closureAction))

  closureAction = {
    "notification": {
      "disp": "Send communications",
      "enable": true,
      "state": 0,
      "mailid": "",
      "phone": null
    }
  }

  //  closureAction={
  //   "notification": {
  //     "disp": "Send Notifications",
  //     "enable": false,
  //     "state": 0,
  //     "mailid": "",
  //     "phone": null
  //   },
  //   "execute_cmd": {
  //     "disp": "Execute Command",
  //     "enable": false,
  //     "state": 0,
  //     "cmd": ""
  //   },
  //   "add_tags": {
  //     "disp": "Add Tags",
  //     "enable": true,
  //     "state": 0,
  //     "tags": [
  //       {}
  //     ]
  //   },
  //   "run_tasks": {
  //     "disp": "Run Tasks",
  //     "enable": false,
  //     "state": 0,
  //     "task": ""
  //   },
  //   "no_action_required":{
  //     "disp":"No Action Required",
  //     "enable":true,
  //     "state":1
  //   }
  // }

  closureAction1 = {}
  closureAction2 = {
    "flagged_for_review": {
      "disp": "Flagged for review",
      "enable": true,
      "state": 0,
      "state_action": {
        "True positive": {
          "id": "1",
          "reason": {
            "1": "Malware Infection",
            "2": "Successful Exploit",
            "3": "Intrusion attempt",
            "4": "Account Compromise",
            "5": "Compliance violation"
          }
        }
      }
    },
    "close": {
      "disp": "Close",
      "enable": true,
      "state": 0,
      "state_action": {
        "Benign true positive": {
          "id": "2",
          "reason": {
            "1": "Red Team",
            "2": "Expected Activity",
            "3": "Authorized Activity",
            "4": "Threat Mitigated Automatically",
            "5": "Potentially Unwanted Program (PUP)",
            "6": "Maintenance",
            "7": "System errors"
          }
        },
        "False positive": {
          "id": "3",
          "reason": {
            "1": "Not Vulnerable",
            "2": "Informational"
          }
        },
        "Undetermined": {
          "id": "4",
          "reason": {
            "1": "Duplicate",
            "2": "Incorrect alert logic"
          }
        }
      }
    }
  }
  // mockClosureAction={
  //   "status":{
  //     "state":{
  //       "0": {
  //         "category": {
  //           "0": {
  //             "reason": {
  //               "0": {
  //                 "value": "-",
  //                 "disp": "-"
  //               }
  //             },
  //             "disp": "-"
  //           }
  //         },
  //         "disp": "-"
  //       },
  //     "disp": "New"
  //     },
  //   "1": {
  //     "state": {
  //       "0": {
  //         "category": {
  //           "0": {
  //             "reason": {
  //               "0": {
  //                 "disp": "Review for False Positive",
  //                 "value": "Review for False Positive"
  //               }
  //             },
  //             "disp": "Review for False Positive"
  //           },
  //           "1": {
  //             "reason": {
  //               "0": {
  //                 "disp": "Review Large data transfer - Email",
  //                 "value": "Review Large data transfer - Email"
  //               }
  //             },
  //             "disp": "Review Large data transfer - Email"
  //           },
  //           "2": {
  //             "reason": {
  //               "0": {
  //                 "disp": "Review Large data transfer - Web",
  //                 "value": "Review Large data transfer - Web"
  //               }
  //             },
  //             "disp": "Review Large data transfer - Web"
  //           }
  //         },
  //         "disp": "Flag for review"
  //       }
  //     },
  //     "disp": "Open"
  //   },
  //   "2": {
  //     "state": {
  //       "0": {
  //         "category": {
  //           "0": {
  //             "reason": {
  //               "0": {
  //                 "disp": "Review for False Positive1",
  //                 "value": "Review for False Positive1"
  //               }
  //             },
  //             "disp": "Review for False Positive1"
  //           },
  //           "1": {
  //             "reason": {
  //               "0": {
  //                 "disp": "Review Large data transfer - Email1",
  //                 "value": "Review Large data transfer - Email1"
  //               }
  //             },
  //             "disp": "Review Large data transfer - Email1"
  //           },
  //           "2": {
  //             "reason": {
  //               "0": {
  //                 "disp": "Review Large data transfer - Web1",
  //                 "value": "Review Large data transfer - Web1"
  //               }
  //             },
  //             "disp": "Review Large data transfer - Web1"
  //           }
  //         },
  //         "disp": "Flag for review1"
  //       }
  //     },
  //     "disp": "Close"
  //   }
  //   }
  // }
  mockClosureAction = this.alertsheetmeta.factsheetMeta.alertUpdateAction.states
  clickedAction = ""
  clickedState = ""
  clickedReason = ""
  clickedStateReason = ""
  openComments: boolean = false





  // commonData: any = this.sharedService.metaData.commonData;
  // tagmapping = {};
  // distag = {};

  tagsSet = new Set();

  ruleConditionEditor: EditorView;
  isInvalid: boolean = true

  conditionsValid: boolean = false

  consolidation = new FormGroup({
    context: new FormGroup({
      description: new FormControl(),
      activate: new FormControl(),
      retroactive: new FormControl()
    }),
    conditions: new FormGroup({
      fields: new FormControl('', Validators.required),
      timeframe: new FormControl('', Validators.required)
    })
  })

  ruleForm = new FormGroup({
    context: new FormGroup({
      ruleName: new FormControl(),
      timeframe: new FormControl(),
      stepsize: new FormControl(),
      activate: new FormControl(),
      retroactive: new FormControl(),
      retro_period: new FormControl(),
      valid_type: new FormControl(),
      valid_for: new FormControl(),
      valid_date: new FormControl(),
      will_expire: new FormControl(false)
    }),
    query: new FormControl(''),
    timeframe: new FormControl(),
    stepsize: new FormControl(),
    comments: new FormControl('', [Validators.maxLength(100)]),
    actions: new FormGroup({
      actionname: new FormControl(),
      closurestate: new FormGroup({
        statename: new FormControl(),
        closurereason: new FormControl()
      }),
      // comments: new FormControl(),
      add_tags: new FormGroup({})
    }),
  })

  resetTestResults() {
    this.testResultVolume = null
  }

  resetRuleForm() {
    this.testResultVolume = null
    this.tagsSet = new Set()
    this.tagsSet.clear();
    this.ruleForm.patchValue({
      context: {
        ruleName: null,
        activate: true,
        retroactive: false
      },
      query: '',
      // timeframe:'',
      // stepsize:'',
      comments: null,
      actions: {
        actionname: null,
        closurestate: {
          statename: null,
          closurereason: null
        },
        // comments: null,
        add_tags: {}
      }
    }, { emitEvent: false });

  }

  compareobjects(obj1: any, obj2: any) {
    return loadash.isEqual(obj1, obj2);
  }

  normalizeActionObj(obj) { // stringify
    const a = obj.actions || {};

    return {
      condition: a.condition || "",
      platform: a.platform || "",
      query: a.query || "",
      action: a.action || "",
      state: a.state || "",
      reason: a.reason || "",

      tokens: (a.tokens?.SearchCommand || []).map(t => ({
        cat: t.cat || "",
        type: t.type || "",
        alias: t.alias || "",
        image: Array.isArray(t.image) ? [...t.image].sort() : t.image || ""
      }))
    };
  }

  // Compare two arrays 
  areRuleSetsSame(set1, set2) {
    // console.log(set1)
    // console.log(set1.length)
    // console.log(set2)
    // console.log(set2.length)
    // if(set1.length != set2.length){
    //   console.log("not equal")
    // }else{
    //   console.log("equal")
    // }
    // console.log("Condition1")
    if (!Array.isArray(set1) || !Array.isArray(set2)) return false;
    // console.log("Condition2")
    if (set1.length != set2.length) return false;

    const norm1 = set1.map(this.normalizeActionObj);
    const norm2 = set2.map(this.normalizeActionObj);

    // console.log({norm1})
    // console.log({norm2})

    const sorter = (a, b) =>
      (a.condition + a.platform + a.query)
        .localeCompare(b.condition + b.platform + b.query);

    norm1.sort(sorter);
    norm2.sort(sorter);
    // console.log(JSON.stringify(norm1) === JSON.stringify(norm2))
    // console.log("Condition3")

    return JSON.stringify(norm1) === JSON.stringify(norm2);
  }




  compareArrayOfObjects(arr1: any[], arr2: any[]) {
    if (arr1.length !== arr2.length) return false;

    for (let i = 0; i < arr1.length; i++) {
      let object1 = arr1[i];
      let object2 = arr2[i];

      let actions1 = object1.actions;
      let actions2 = object2.actions;

      for (let key in actions1) {
        if (key === "platform" || key === "engineQuery") continue;

        if (key === "add_tags") {
          let tags1 = actions1[key].tags;
          let tags2 = actions2[key].tags;

          for (let tagKey in tags1) {
            if (!(tagKey in tags2)) return false;

            for (let tagValKey in tags1[tagKey]) {
              if (tags1[tagKey][tagValKey] !== tags2[tagKey][tagValKey]) {
                return false;
              }
            }
          }
        } else {
          if (actions1[key] !== actions2[key]) {
            //console.log("Not Equal:", key);
            return false;
          }
        }
      }
    }

    return true;
  }


  // compareArrayOfObjects(arr1:any[],arr2:any[]){ // To Compare Array of Objects
  //   let returnVal:boolean
  //   Object.keys(arr1).forEach(key=>{
  //     Object.keys(arr1[key].actions).forEach(val=>{
  //       if(val!="platform" && val!="engineQuery"){
  //         if(val=="add_tags"){
  //           Object.keys(arr1[key].actions[val].tags).forEach(tagKey=>{
  //             Object.keys(arr1[key].actions[val].tags[tagKey]).forEach(tagval=>{
  //               if(arr1[key].actions[val].tags[tagKey][tagval]==arr2[key].actions[val].tags[tagKey][tagval]){
  //                 returnVal=true
  //                 // return true
  //               }
  //               else{
  //                 returnVal=false

  //                 // return false
  //               }
  //             })
  //           })
  //         }
  //         else{
  //           if(arr1[key].actions[val]===arr2[key].actions[val]){
  //             returnVal=true
  //             // return true
  //           }
  //           else{
  //             console.log("Not Equal",val)
  //             returnVal=false
  //             console.log("returnVal 1 ====---->",returnVal)

  //             // return false

  //           }

  //         }
  //       }
  //     })
  //   })
  //   console.log("returnVal====---->",returnVal)
  //   return returnVal

  // }


  emptyTags = {
    "killchain": {
      "reconnaissance": false,
      "threatgroup1319": false
    },
    "compliance": {
      "pcidss": false,
      "gprc": false,
      "iso27001": false,
      "hippa": false,
      "low_diskspace": false,
      "connection_attempt": false,
      "gdpr": false,
      "exploit_attempt": false,
      "invalid_login": false,
      "config_changed": false,
      "authentication_failures": false,
      "promisc": false,
      "gpg": false,
      "tsc": false,
      "recon": false,
      "nist": false,
      "system_shutdown": false,
      "authentication_failed": false,
      "authentication_success": false,
      "service_availability": false,
      "access_denied": false
    },
    "mitreattack": {
      "command_and_control": false,
      "credential_access": false,
      "defense_evasion": false,
      "execution": false,
      "impact": false,
      "lateral_movement": false,
      "persistence": false,
      "privilege_escalation": false,
      "resource_development": false,
      "t1003": false,
      "t1003.001": false,
      "t1008": false,
      "t1021.002": false,
      "t1036.003": false,
      "t1047": false,
      "t1053": false,
      "t1053.005": false,
      "t1059.005": false,
      "t1059.007": false,
      "t1070.005": false,
      "t1105": false,
      "t1112": false,
      "t1133": false,
      "t1137": false,
      "t1137.006": false,
      "t1140": false,
      "t1202": false,
      "t1203": false,
      "t1204.002": false,
      "t1218": false,
      "t1218.011": false,
      "t1221": false,
      "t1490": false,
      "t1543.003": false,
      "t1546": false,
      "t1546.009": false,
      "t1546.011": false,
      "t1546.012": false,
      "t1546.015": false,
      "t1547.001": false,
      "t1547.003": false,
      "t1547.004": false,
      "t1547.010": false,
      "t1548": false,
      "t1548.002": false,
      "t1553.003": false,
      "t1559.002": false,
      "t1562": false,
      "t1562.001": false,
      "t1562.002": false,
      "t1562.004": false,
      "t1564": false,
      "t1564.001": false,
      "t1564.002": false,
      "t1566": false,
      "t1569.002": false,
      "t1574": false,
      "t1574.002": false,
      "t1574.012": false,
      "t1588.002": false,
      "2013-01-002": false,
      "2019-04-001": false,
      "discovery": false,
      "t1059-001": false,
      "t1027": false,
      "t1059.001": false,
      "t1049": false,
      "initial_access": false,
      "t1078": false,
      "t1069.001": false,
      "collection": false,
      "t1074.001": false,
      "t1136.001": false,
      "g0049": false,
      "s0111": false,
      "t1071.004": false,
      "t1218.003": false,
      "s0005": false,
      "t1137.002": false,
      "t1090": false,
      "t1547": false,
      "2014-11-003 ": false,
      "2014-11-008": false,
      "exfiltration": false,
      "g0001": false,
      "g0004": false,
      "g0007": false,
      "g0009": false,
      "g0010": false,
      "g0016": false,
      "g0020": false,
      "g0022": false,
      "g0027": false,
      "g0030": false,
      "g0032": false,
      "g0035": false,
      "g0044": false,
      "g0045": false,
      "g0046": false,
      "g0047": false,
      "g0050": false,
      "g0060": false,
      "g0064": false,
      "g0069": false,
      "g0075": false,
      "g0091": false,
      "g0092": false,
      "g0093": false,
      "g0096": false,
      "g0115": false,
      "g0128": false,
      "reconnaissance": false,
      "s0002": false,
      "s0013": false,
      "s0029": false,
      "s0039": false,
      "s0040": false,
      "s0075": false,
      "s0081": false,
      "s0106": false,
      "s0108": false,
      "s0160": false,
      "s0190": false,
      "s0195": false,
      "s0246": false,
      "s0363": false,
      "s0404": false,
      "s0412": false,
      "s0575": false,
      "t1001.003": false,
      "t1003.002": false,
      "t1003.003": false,
      "t1003.004": false,
      "t1003.005": false,
      "t1003.006": false,
      "t1005": false,
      "t1007": false,
      "t1010": false,
      "t1012": false,
      "t1016": false,
      "t1018": false,
      "t1020": false,
      "t1021": false,
      "t1021.001": false,
      "t1021.003": false,
      "t1021.004": false,
      "t1021.005": false,
      "t1021.006": false,
      "t1027.001": false,
      "t1027.003": false,
      "t1027.004": false,
      "t1027.005": false,
      "t1027.009": false,
      "t1033": false,
      "t1035": false,
      "t1036": false,
      "t1036.002": false,
      "t1036.004": false,
      "t1036.005": false,
      "t1036.007": false,
      "t1037.001": false,
      "t1039": false,
      "t1040": false,
      "t1041": false,
      "t1046": false,
      "t1048": false,
      "t1048.001": false,
      "t1048.003": false,
      "t1050": false,
      "t1053.002": false,
      "t1055": false,
      "t1055.001": false,
      "t1056.001": false,
      "t1057": false,
      "t1059": false,
      "t1059.003": false,
      "t1059.006": false,
      "t1068": false,
      "t1069": false,
      "t1069.002": false,
      "t1070": false,
      "t1070.001": false,
      "t1070.003": false,
      "t1070.004": false,
      "t1070.006": false,
      "t1070.008": false,
      "t1071": false,
      "t1071.001": false,
      "t1072": false,
      "t1078.001": false,
      "t1078.002": false,
      "t1078.003": false,
      "t1082": false,
      "t1083": false,
      "t1087": false,
      "t1087.001": false,
      "t1087.002": false,
      "t1090.001": false,
      "t1090.002": false,
      "t1090.003": false,
      "t1091": false,
      "t1095": false,
      "t1098": false,
      "t1102": false,
      "t1104": false,
      "t1106": false,
      "t1110": false,
      "t1110.001": false,
      "t1110.002": false,
      "t1110.003": false,
      "t1113": false,
      "t1114": false,
      "t1114.001": false,
      "t1115": false,
      "t1119": false,
      "t1120": false,
      "t1123": false,
      "t1124": false,
      "t1125": false,
      "t1127": false,
      "t1127.001": false,
      "t1132.001": false,
      "t1134.001": false,
      "t1134.002": false,
      "t1134.003": false,
      "t1134.004": false,
      "t1134.005": false,
      "t1135": false,
      "t1136.002": false,
      "t1176": false,
      "t1185": false,
      "t1187": false,
      "t1190": false,
      "t1197": false,
      "t1200": false,
      "t1201": false,
      "t1204": false,
      "t1207": false,
      "t1210": false,
      "t1211": false,
      "t1212": false,
      "t1216": false,
      "t1216.001": false,
      "t1217": false,
      "t1218.001": false,
      "t1218.002": false,
      "t1218.004": false,
      "t1218.005": false,
      "t1218.007": false,
      "t1218.008": false,
      "t1218.009": false,
      "t1218.010": false,
      "t1218.013": false,
      "t1219": false,
      "t1220": false,
      "t1222": false,
      "t1222.001": false,
      "t1482": false,
      "t1484.001": false,
      "t1485": false,
      "t1486": false,
      "t1489": false,
      "t1491.001": false,
      "t1496": false,
      "t1497.001": false,
      "t1499.001": false,
      "t1499.004": false,
      "t1505.002": false,
      "t1505.003": false,
      "t1505.005": false,
      "t1518": false,
      "t1518.001": false,
      "t1526": false,
      "t1528": false,
      "t1529": false,
      "t1531": false,
      "t1539": false,
      "t1542.001": false,
      "t1542.003": false,
      "t1543": false,
      "t1546.001": false,
      "t1546.002": false,
      "t1546.003": false,
      "t1546.007": false,
      "t1546.008": false,
      "t1546.010": false,
      "t1546.013": false,
      "t1547.002": false,
      "t1547.005": false,
      "t1547.008": false,
      "t1547.009": false,
      "t1547.014": false,
      "t1550.002": false,
      "t1550.003": false,
      "t1552.001": false,
      "t1552.002": false,
      "t1552.004": false,
      "t1552.006": false,
      "t1553": false,
      "t1553.002": false,
      "t1553.004": false,
      "t1553.005": false,
      "t1554": false,
      "t1555": false,
      "t1555.003": false,
      "t1555.004": false,
      "t1556": false,
      "t1556.002": false,
      "t1557": false,
      "t1557.001": false,
      "t1558": false,
      "t1558.003": false,
      "t1560": false,
      "t1560.001": false,
      "t1562.006": false,
      "t1562.010": false,
      "t1563.002": false,
      "t1564.003": false,
      "t1564.004": false,
      "t1564.006": false,
      "t1565": false,
      "t1566.001": false,
      "t1567": false,
      "t1567.002": false,
      "t1569": false,
      "t1570": false,
      "t1571": false,
      "t1572": false,
      "t1573": false,
      "t1574.001": false,
      "t1574.005": false,
      "t1574.007": false,
      "t1574.011": false,
      "t1584": false,
      "t1587": false,
      "t1587.001": false,
      "t1588": false,
      "t1590.001": false,
      "t1590.002": false,
      "t1593.003": false,
      "t1608": false,
      "t1615": false,
      "t1620": false,
      "t1649": false,
      "car.2013-01-002": false,
      "car.2013-02-003": false,
      "car.2013-03-001": false,
      "car.2013-04-002": false,
      "car.2013-05-002": false,
      "car.2013-05-004": false,
      "car.2013-05-009": false,
      "car.2013-07-001": false,
      "car.2013-07-002": false,
      "car.2013-08-001": false,
      "car.2013-09-005": false,
      "car.2013-10-002": false,
      "car.2014-04-003": false,
      "car.2014-11-003": false,
      "car.2014-11-008": false,
      "car.2015-04-001": false,
      "car.2016-03-001": false,
      "car.2016-03-002": false,
      "car.2016-04-002": false,
      "car.2016-04-004": false,
      "car.2016-04-005": false,
      "car.2019-04-001": false,
      "car.2019-04-002": false,
      "car.2019-04-003": false,
      "car.2019-04-004": false,
      "cve.2015.1641": false,
      "cve.2017.0261": false,
      "cve.2017.11882": false,
      "cve.2017.8759": false,
      "cve.2019.1388": false,
      "cve.2020.10189": false,
      "cve.2020.1048": false,
      "cve.2020.1350": false,
      "cve.2020.1472": false,
      "cve.2020.1599": false,
      "cve.2021.1675": false,
      "cve.2021.26084": false,
      "cve.2021.26857": false,
      "cve.2021.31979": false,
      "cve.2021.33771": false,
      "cve.2021.34527": false,
      "cve.2021.35211": false,
      "cve.2021.40444": false,
      "cve.2021.41379": false,
      "cve.2021.42278": false,
      "cve.2021.42287": false,
      "cve.2022.29072": false,
      "cve.2022.41120": false,
      "cve.2023.21746": false,
      "cve.2023.23397": false,
      "cve.2023.36884": false,
      "detection.emerging_threats": false,
      "detection.threat_hunting": false,
      "t1548.003": false,
      "t1053.003": false,
      "t1136": false,
      "t1499": false,
      "t1547.006": false,
      "RDP": false
    },
    "threatgroup": {
      "apt24": false,
      "apt25": false
    }
  }
  ResetTags: boolean = false

  resetTags() {
    // this.ResetTags=true
    //console.log("Reset Tags before",this.autoInvestigate.value.conditions)
    // this.tagmapping = {};
    // this.distag = {};
    this.tagsSet.clear();
    // this.tagsSet=new Set()
    this.ruleForm.patchValue({
      actions: {
        add_tags: {
          tags: this.emptyTags
        }
      }
    }, { emitEvent: false });
    //console.log("Reset Tags after",this.autoInvestigate.value.conditions)
  }

  getaddTags() {
    return this.ruleForm.get('actions').get('add_tags') as FormGroup
  }




  errorState = new Array(3).fill(false);
  errorType = { "101": "Invalid Condition", "102": "StepSize is bigger than Timeframe" }

  time = [
    {
      "disp": "Last 1 Hour",
      "value": [
        -1,
        "hour",
        1
      ]
    },
    {
      "disp": "Last 3 Hour",
      "value": [
        -1,
        "hour",
        3
      ]
    },
    {
      "disp": "Last 24 Hour",
      "value": [
        -1,
        "hour",
        24
      ]
    },
    {
      "disp": "Today",
      "value": [
        0,
        "today",
        0
      ]
    },
    {
      "disp": "Yesterday",
      "value": [
        -1,
        "yesterday",
        1
      ]
    },
    {
      "disp": "last 7 Days",
      "value": [
        -1,
        "day",
        6
      ]
    },
    {
      "disp": "Last 30 Days",
      "value": [
        -1,
        "day",
        29
      ]
    },
    {
      "disp": "Last 90 Days",
      "value": [
        -1,
        "day",
        89
      ]
    },
    {
      "disp": "Last 120 Days",
      "value": [
        -1,
        "day",
        119
      ]
    },
    {
      "disp": "Last 180 Days",
      "value": [
        -1,
        "day",
        179
      ]
    },
    {
      "disp": "Last 300 Days",
      "value": [
        -1,
        "day",
        299
      ]
    }
  ]

  // alertFilter={"time":[
  //   {
  //       "disp": "Last 1 Hour",
  //       "value": [
  //           -1,
  //           "hour",
  //           1
  //       ]
  //   },
  //   {
  //       "disp": "Last 3 Hour",
  //       "value": [
  //           -1,
  //           "hour",
  //           3
  //       ]
  //   },
  //   {
  //       "disp": "Last 24 Hour",
  //       "value": [
  //           -1,
  //           "hour",
  //           24
  //       ]
  //   },
  //   {
  //       "disp": "Today",
  //       "value": [
  //           0,
  //           "today",
  //           0
  //       ]
  //   },
  //   {
  //       "disp": "Yesterday",
  //       "value": [
  //           -1,
  //           "yesterday",
  //           1
  //       ]
  //   },
  //   {
  //       "disp": "last 7 Days",
  //       "value": [
  //           -1,
  //           "day",
  //           6
  //       ]
  //   },
  //   {
  //       "disp": "Last 30 Days",
  //       "value": [
  //           -1,
  //           "day",
  //           29
  //       ]
  //   },
  //   {
  //       "disp": "Last 90 Days",
  //       "value": [
  //           -1,
  //           "day",
  //           89
  //       ]
  //   },
  //   {
  //       "disp": "Last 120 Days",
  //       "value": [
  //           -1,
  //           "day",
  //           119
  //       ]
  //   },
  //   {
  //       "disp": "Last 180 Days",
  //       "value": [
  //           -1,
  //           "day",
  //           179
  //       ]
  //   },
  //   {
  //       "disp": "Last 300 Days",
  //       "value": [
  //           -1,
  //           "day",
  //           299
  //       ]
  //   }
  // ],
  // "platform":[
  //   {"disp":"Firewall Fortigate","value":"firewall_fortigate","count": 10298},
  //   {"disp":"Cisco Switch","value":"cisco_switch","count": 456},
  //   {"disp":"Firewall PaloAlto","value":"firewall_paloalto","count": 987}
  // ]
  // }

  atomicStruct = { // Copied from rulevarservice
    structureChange(ruleData: any, searchTokens: any[]) {
      const searchtokens = [...searchTokens];
      return searchtokens;
    }
  }
  structureRuleType = { "auto-investigate": this.atomicStruct }

  toengineQuery(ruleData: any, searchtokens: any[]) {
    // return this.structureRuleType[ruleData.context.ruleType].structureChange(ruleData,searchtokens)
    return this.structureRuleType['auto-investigate'].structureChange(ruleData, searchtokens)

  }

  //alertcommon
  summaryPanelLabel = "Filters"
  eventsPanelLabel = "Details"
  selectedAlerts: any = {};
  alertSummaryCountDetails: any = { has_alerts: 0, has_no_alerts: 0 }
  // alertsheetmeta: any = JSON.parse(JSON.stringify(this.sharedService.metaData.alert));
  // advanced_filter_timeMeta:any
  commondata: any = this.sharedService.metaData.commonData;
  timecalc = new TimeDiffCalc(this.timezoneservice);
  platformMap = this.sharedService.platformMap;
  alertselectedIndex: number = 0;
  alertEventSelectedIndex: number = 0;
  factSheetOpened: boolean = false;
  $alertStatusUpdated: Subject<boolean> = new Subject()


  eventsreqobj: any = {};
  eventsSelectAll = new FormControl(false);
  alertstatus = new FormControl('0');
  assigned_user = new UntypedFormControl([])
  userlist = {}
  eventsItemperpage = new FormControl(25);
  eventspagenumber = 1;
  eventspagelength = 1;
  alertEventsListView = true;
  selectedEventPagenumber = 1;
  selectedEventPagelenght = 1;

  alertWorkFlowInfo = {
    paginationDataWorkFlowAlert: [],
    selectedAlerts: {},
    alertKeys_list: [],
    selectedeventspagenumber: 1,
    selectedeventspagelength: 1,
    selectedAlertsEnable: true,
    alertWorkFlowSelectAll: new FormControl(false),
    alertWorkFlowSearch: new FormControl(''),
    alertWorkFloweventsItemperpage: new FormControl(25)
  }

  alertSearchInfo = {
    invalidSearchKeyStatus: false,
    alertSearchState: false,
    searchval: '',
    status: [],
    statusreason: []
  }

  //additional filter variables
  selectedInstantFilter: any = {}
  limitfilter: FormControl = new FormControl('Show all');
  limitfilter_list: Array<string> = [];
  filterpannelexpanded: Object = {};
  filterslist: Array<Object> = [];
  advancefilter_state: boolean = true;
  advancefilter_header = "Additional filter";
  advancefilter_pannelexpanded: boolean = false;

  filter = new FormGroup({
    filtercondition: new FormArray([])
  });

  autoInv = new FormGroup({
    conditions: new FormArray([])
  })

  // operator: FormControl = new FormControl(this.default)
  searchInput: FormControl = new FormControl('');
  overLayRef: any;
  wb_meta = this.sharedService.metaData.studio.widget_builder;
  additional_filter_operator_label = "Add conditions by" // to be meta
  additional_filter_condition_label = "ADD CONDITION"
  additional_filter_scenario_label = "ADD SCENARIO"

  // platformfields = [...this.sharedService.commonPlatformFields];
  eventFieldOptions: any = [];






  // alert action metadata
  // updateActionMetadata: any = {
  //   "defaultActionStatus": "flagged_for_review",
  //   "defaultActionState": "True positive",
  //   "actions": {
  //     "flagged_for_review": {
  //       "disp": "Flagged for review",
  //       "state_action": {
  //         "True positive": {
  //           "id": "1",
  //           "reason": {
  //             "1": "Malware Infection",
  //             "2": "Successful Exploit",
  //             "3": "Intrusion attempt",
  //             "4": "Account Compromise",
  //             "5": "Compliance violation"
  //           }
  //         }
  //       },
  //     },
  //     "close": {
  //       "disp": "Close",
  //       "state_action": {
  //         "Benign true positive": {
  //           "id": "2",
  //           "reason": {
  //             "1": "Red Team",
  //             "2": "Expected Activity",
  //             "3": "Authorized Activity",
  //             "4": "Threat Mitigated Automatically",
  //             "5": "Potentially Unwanted Program (PUP)",
  //             "6": "Maintenance",
  //             "7": "System errors"
  //           }
  //         },
  //         "False positive": {
  //           "id": "3",
  //           "reason": {
  //             "1": "Not Vulnerable",
  //             "2": "Informational"
  //           }
  //         },
  //         "Undetermined": {
  //           "id": "4",
  //           "reason": {
  //             "1": "Duplicate",
  //             "2": "Incorrect alert logic"
  //           }
  //         }
  //       }
  //     }
  //   },
  //   "errors": {
  //     "actionstate": "Select atleast one state",
  //     "reason": "Select atleast one reason",
  //     "invalidSearchKeymsg": "Invalid search key"
  //   },
  //   "action_disp_old": {
  //     "Flagged for review": "Review",
  //     "Close": "Close",
  //     "open": "Open",
  //     "True positive": "TP",
  //     "Benign true positive": "B-TP",
  //     "False positive": "FP",
  //     "Undetermined": "UD",
  //     "-": "-"
  //   },
  //   "action_disp": {
  //     "0": {
  //       "status_disp": "Open",
  //       "status_val": "Open",
  //       "state_disp": "-",
  //       "state_val": "-"
  //     },
  //     "1": {
  //       "status_disp": "Flagged for review",
  //       "status_val": "Review",
  //       "state_disp": "True positive",
  //       "state_val": "TP"
  //     },
  //     "2": {
  //       "status_disp": "Close",
  //       "status_val": "Close",
  //       "state_disp": "Benign true positive",
  //       "state_val": "B-TP"
  //     },
  //     "3": {
  //       "status_disp": "Close",
  //       "status_val": "Close",
  //       "state_disp": "False positive",
  //       "state_val": "FP"
  //     },
  //     "4": {
  //       "status_disp": "Close",
  //       "status_val": "Close",
  //       "state_disp": "Undetermined",
  //       "state_val": "UD"
  //     }
  //   }

  // }
  updateActionMetadata: any = this.alertsheetmeta.factsheetMeta.alertUpdateAction

  addconditionSet() {
    if (this.filtercondition.controls.length < 3) {
      const conditionset = new FormGroup({
        operationconditionLine: new FormControl(true),
        conditionLines: new FormArray([
          this.addCondition()
        ]),
        operationConditionset: new FormControl()
      })
      this.filtercondition.push(conditionset);
      if (this.filtercondition.length > 1) {
        this.filtercondition.controls[this.filtercondition.length - 2].get('operationConditionset').setValue('AND');
      }
    }
  }

  addCondition() {
    return new FormGroup({
      eventField: new FormControl(),
      operator: new FormControl(this.wb_meta.wdigetpannel.filter_condition.default),
      conditionValue: new FormArray([]),
      conditionInput: new FormControl(''),
    }
      , {
        validators: [ValueValidator()]
      }
    )
  }

  //   get conditions(){
  //     return this.autoInv.get('conditions') as FormArray;
  //   }

  //  alertlines(){
  //     return this.conditions.at(index).get('alertlines') as FormArray
  //   }







  get filtercondition() {
    return this.filter.get('filtercondition') as FormArray;
  }

  conditionlines(index: number) {
    return this.filtercondition.at(index).get('conditionLines') as FormArray;
  }

  conditioneventField(setindex: number, lineindex: number) {
    return this.conditionlines(setindex).at(lineindex).get('eventField');
  }

  conditionvalue(setindex: number, lineindex: number) {
    return this.conditionlines(setindex).controls[lineindex].get('conditionValue') as FormArray;
  }

  conditionSetButtonValue(index: number) {
    return this.filtercondition.at(index).get('operationConditionset');
  }

  operatorField(setindex: number, lineindex: number) {
    return this.conditionlines(setindex).controls[lineindex].get('operator');
  }

  conditionInputField(setindex: number, lineindex: number) {
    return this.conditionlines(setindex).at(lineindex).get('conditionInput');
  }

  conditionGroup(setindex: number, lineindex: number) {
    return this.conditionlines(setindex).at(lineindex);
  }

  addFilterCondition(setindex: number) {
    if (this.conditionlines(setindex).controls.length < 5) {
      this.conditionlines(setindex).push(this.addCondition());
      // this.conditionlines(setindex).setControl(setindex+1,this.addCondition());
    }
    // this.conditionlines(setindex).setControl(setindex+1,this.addCondition());
    // this.conditionlines(setindex).insert(setindex+1,this.addCondition());
    // console.log("SetIndex",setindex)

  }


  // addFilterCondition1(setindex: number,index:number) {
  //   if (this.conditionlines(setindex).controls.length < 5) {
  //     this.conditionlines(setindex).push(this.addCondition());
  // this.conditionlines(setindex).setControl(setindex+1,this.addCondition());
  // }
  // this.conditionlines(setindex).setControl(setindex+1,this.addCondition());
  // this.conditionlines(setindex).insert(index+1,this.addCondition());
  // console.log("SetIndex",index)
  // console.log(this.conditionlines(setindex))

  // }


  removeValueChip_click(setindex: number, lineindex: number, removeindex: number) {
    let condval = this.conditionvalue(setindex, lineindex);
    condval.removeAt(removeindex);
    if (condval.length < 2) {
      this.overLayRef?.close();
    }
  }
  conditionSetButtonClick(index: number) {
    let conditionsetButton = this.conditionSetButtonValue(index)
    if (conditionsetButton.value == 'OR') {
      conditionsetButton.setValue('AND')
    } else {
      conditionsetButton.setValue('OR')
    }
  }
  addfirstset = this.addconditionSet();



  processplatformFields(platformFields: any[]) {
    const arr = [];
    for (let i = 0; i < platformFields.length; i++) {
      arr.push({
        disp: platformFields[i].disp,
        value: {
          field: platformFields[i].disp,
          type: platformFields[i].type,
          display_type: platformFields[i].display_type
        }
      })
    }
    return arr;
  }


  //factsheet var
  eventsPanel: number = FactsheetEventsPanel.collapse;
  summaryPanel: number = FactsheetSummaryPanel.collapse;
  // isVisibleEvents: boolean = false;
  // isEventsTable: boolean = false;
  advancedFilterChange: Subject<null> = new Subject();
  alertEventsSearch: FormControl = new FormControl('');

  nodeinfo: any = null;
  filters = []
  applied_filters = []
  template_structure = {}



  // fetch to be metadata
  exculsivefilters = []
  mutual_exclusive_filters = {}
  mutual_exclusive_filters_template = {
    "time": {
      "hasEventTimeBizHours": {
        "label": "hasEventTimeBizHours",
        "category": "time",
        "isEnable": 1,
        "isSelected": false,
        "ifilter_desc": "and (a.episode%86400-a.episode%3600)/3600 between 10 and 17",
        "ifilter_type": "~~eventtime_condition"
      },
      "hasEventTimeNonBizHours": {
        "label": "hasEventTimeNonBizHours",
        "category": "time",
        "isEnable": 1,
        "isSelected": false,
        "ifilter_desc": "and not (a.episode%86400-a.episode%3600)/3600 between 10 and 17",
        "ifilter_type": "~~eventtime_condition"
      }
    },
    "general": {
      "hasFieldTypeInteger": {
        "label": "hasFieldTypeInteger",
        "category": "general",
        "isEnable": 1,
        "isSelected": false,
        "ifilter_desc": "and field_name in (select field_name from ~~schema.platform_field where  display_type != 'text')",
        "ifilter_type": "~~condition"
      },
      "hasFieldTypeString": {
        "label": "hasFieldTypeString",
        "category": "general",
        "isEnable": 1,
        "isSelected": false,
        "ifilter_desc": "and field_name in (select field_name from ~~schema.platform_field where  display_type = 'text')",
        "ifilter_type": "~~condition"
      }
    }
  }



  applied_mutual_exclusive_filters = {
    ...this.mutual_exclusive_filters
  }

  // instantfilters = {
  //   "contributingSource": {
  //     "limit": [
  //       {
  //         "label": "isRankedByCountBottom5",
  //         "category": "limit",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "order by count  limit 5",
  //         "ifilter_type": "~~order_by"
  //       },
  //       {
  //         "label": "isRankedByCountTop5",
  //         "category": "limit",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "order by count desc limit 5",
  //         "ifilter_type": "~~order_by"
  //       },
  //       {
  //         "label": "Show all",
  //         "category": "limit",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       }
  //     ],
  //     "statistics": [
  //       {
  //         "label": "hasEventCountHigh",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasEventCountLow",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasEventCountNonZero",
  //         "category": "statistics",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasEventCountZero",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasRiskScoreHigh",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "isCritical",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       }
  //     ],
  //     "time": [
  //       {
  //         "label": "hasEventTimeBizHours",
  //         "category": "time",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "and (a.episode%86400-a.episode%3600)/3600 between 10 and 17",
  //         "ifilter_type": "~~eventtime_condition"
  //       },
  //       {
  //         "label": "hasEventTimeNonBizHours",
  //         "category": "time",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "and not (a.episode%86400-a.episode%3600)/3600 between 10 and 17",
  //         "ifilter_type": "~~eventtime_condition"
  //       }
  //     ]
  //   },
  //   "hasField": {
  //     "general": [
  //       {
  //         "label": "hasFieldTypeDatetime",
  //         "category": "general",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasFieldTypeInteger",
  //         "category": "general",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "and field_name in (select field_name from ~~schema.platform_field where  display_type != 'text')",
  //         "ifilter_type": "~~condition"
  //       },
  //       {
  //         "label": "hasFieldTypeString",
  //         "category": "general",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "and field_name in (select field_name from ~~schema.platform_field where  display_type = 'text')",
  //         "ifilter_type": "~~condition"
  //       }
  //     ],
  //     "limit": [
  //       {
  //         "label": "Show all",
  //         "category": "limit",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       }
  //     ],
  //     "statistics": [
  //       {
  //         "label": "hasFieldDistinctCountHigh",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasFieldDistinctCountLow",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasFieldDistinctCountOne",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "isFieldValueOutOfRange",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       }
  //     ]
  //   },
  //   "hasNoField": {
  //     "general": [
  //       {
  //         "label": "hasFieldTypeDatetime",
  //         "category": "general",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasFieldTypeInteger",
  //         "category": "general",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasFieldTypeString",
  //         "category": "general",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       }
  //     ]
  //   },
  //   "hasValues": {
  //     "general": [
  //       {
  //         "label": "hasValueTypeDatetime",
  //         "category": "general",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasValueTypeInteger",
  //         "category": "general",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasValueTypeString",
  //         "category": "general",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       }
  //     ],
  //     "statistics": [
  //       {
  //         "label": "hasValueDistinctCountHigh",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasValueDistinctCountLow",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasValueDistinctCountOne",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "isFrequencyRare",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "isRare",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       }
  //     ]
  //   },
  //   "isInEpisode": {
  //     "limit": [
  //       {
  //         "label": "isRankedByCountBottom5",
  //         "category": "limit",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "order by count  limit 5",
  //         "ifilter_type": "~~order_by"
  //       },
  //       {
  //         "label": "isRankedByCountTop5",
  //         "category": "limit",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "order by count desc limit 5",
  //         "ifilter_type": "~~order_by"
  //       },
  //       {
  //         "label": "Show all",
  //         "category": "limit",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       }
  //     ],
  //     "statistics": [
  //       {
  //         "label": "hasEventCountHigh",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasEventCountLow",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasEventCountNonZero",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "hasEventCountZero",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       }
  //     ],
  //     "time": [
  //       {
  //         "label": "hasEventTimeBizHours",
  //         "category": "time",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "and (a.episode%86400-a.episode%3600)/3600 between 10 and 17",
  //         "ifilter_type": "~~eventtime_condition"
  //       },
  //       {
  //         "label": "hasEventTimeNonBizHours",
  //         "category": "time",
  //         "isEnable": 1,
  //         "isSelected": false,
  //         "ifilter_desc": "and not (a.episode%86400-a.episode%3600)/3600 between 10 and 17",
  //         "ifilter_type": "~~eventtime_condition"
  //       }
  //     ]
  //   },
  //   "nonContributingSource": {
  //     "statistics": [
  //       {
  //         "label": "hasRiskScoreHigh",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       },
  //       {
  //         "label": "isCritical",
  //         "category": "statistics",
  //         "isEnable": 0,
  //         "isSelected": false,
  //         "ifilter_desc": "",
  //         "ifilter_type": ""
  //       }
  //     ]
  //   }
  // }

  // info tab
  instantfilters: any = {}
  latestselected_alert: Object = {}
  historyList = [];
  notesList = []
  addNotesList = [
    "Confirmed malicious activity. Escalate for immediate response.",
    "False positive detected, no further action required.",
    "User behavior appears anomalous but non-malicious. Continue monitoring.",
    "Potential insider threat. Investigate user activities.",
    "Network traffic spike from IP address appears suspicious. Block and analyze.",
    "Malware signature detected. Initiate malware scan on affected endpoints.",
    "Alert triggered by misconfigured system. Schedule corrective measures.",
    "Unauthorized access attempt detected. Reassess access controls.",
    "Recurrent alert pattern observed. Consider refining detection rule.",
    "New unknown device detected on the network. Assess security posture.",
    "Critical vulnerability exploited. Patch required immediately.",
    "Suspicious login from unusual geographic location. Verify with user.",
    "Phishing attempt suspected. Notify and educate end-user.",
    "Increased login failures from this endpoint. Possible brute-force attack.",
    "Suspicious file upload detected. Quarantine and analyze.",
    "Alert correlates with active incident investigation. Tag and proceed.",
    "Indicators of Compromise (IoCs) match known threat actors. Deepen analysis.",
    "File integrity violation detected. Investigate change history.",
    "Privileged account usage flagged. Validate activities.",
    "Excessive data transfer detected from internal resource. Review data flow.",
    "Configuration baseline altered without change request. Audit required.",
    "Compliance-related incident detected. Report to compliance officer.",
    "Service misbehavior. Consider adjusting threshold for alert.",
    "Unusual DNS requests detected. Possible command-and-control activity.",
    "Alert suppressed based on pre-defined policy. Confirm necessity of suppression."]
  detailsSearch = new FormControl("");
  notesSearch = new FormControl("");
  detailsSelectall = new FormControl(false);

  overviewDetails = [];
  rootNodeEpisodesCount: number = 0
  rootNodeEntityFields: any = []
  alertInsightTable: any = []
  alertNonEntityFields: any = []
  //details variables
  currentIndex = 0

  nodesummarydata = {
    series: [],
  };
  nodeSummaryDetailSelectedCount: number = 0;

  //events
  AlertEvents = {}
  AlertEventsKeyList = [];
  eventlist = [];
  chart_ref_no = "";
  additionalEvents = [
    {
      "event_TS": "2024-10-04 23:43:47",
      "dhost": "C4307BCKMKM6Y6C",
      "description": "Controlled application detected: Microsoft Powershell (System tool)",
      "duid": "5d6a668f3c266910a3517f1e",
      "filepath": "nil",
      "core_remedy_sophosPid": "nil",
      "core_remedy_result": "nil",
      "product_name": "sophos central",
      "customer_id": "f0d877a8-a5e2-41ae-a9a9-2656086a8bb5",
      "format": "CEF",
      "threat_cleanable": "nil",
      "threat": "nil",
      "product_version": "1.0",
      "endpoint_type": "computer",
      "severity": "1",
      "created_at": "nil",
      "core_remedy_descriptor": "nil",
      "source_info_ip": "10.0.4.248",
      "core_remedy_suspendResult": "nil",
      "appCerts": "nil",
      "endpoint_java_id": "nil",
      "origin": "nil",
      "suser": "Administrator",
      "datastream": "event",
      "vendor_name": "sophos",
      "detection_identity_name": "nil",
      "ComputerName": "C4307BCKMKM6Y6C",
      "format_version": "0",
      "name": "nil",
      "endpoint_platform": "nil",
      "user_match_id": "nil",
      "inserted_at": "nil",
      "group": "APPLICATION_CONTROL",
      "appSha256": "nil",
      "core_remedy_processPath": "nil",
      "threat_id": "nil",
      "core_remedy_type": "nil",
      "core_remedy_items_totalItems": "0",
      "endpoint_id": "2d5e5b88-8071-42b3-9214-e49660c8b715",
      "type": "Event::Endpoint::Application::Detected"
    },
    {
      "event_TS": "2024-10-04 23:42:16",
      "dhost": "C4307BCKMKM6Y6C",
      "description": "Controlled application detected: Microsoft Powershell (System tool)",
      "duid": "5d6a668f3c266910a3517f1e",
      "filepath": "nil",
      "core_remedy_sophosPid": "nil",
      "core_remedy_result": "nil",
      "product_name": "sophos central",
      "customer_id": "f0d877a8-a5e2-41ae-a9a9-2656086a8bb5",
      "format": "CEF",
      "threat_cleanable": "nil",
      "threat": "nil",
      "product_version": "1.0",
      "endpoint_type": "computer",
      "severity": "1",
      "created_at": "nil",
      "core_remedy_descriptor": "nil",
      "source_info_ip": "10.0.4.248",
      "core_remedy_suspendResult": "nil",
      "appCerts": "nil",
      "endpoint_java_id": "nil",
      "origin": "nil",
      "suser": "Administrator",
      "datastream": "event",
      "vendor_name": "sophos",
      "detection_identity_name": "nil",
      "ComputerName": "C4307BCKMKM6Y6C",
      "format_version": "0",
      "name": "nil",
      "endpoint_platform": "nil",
      "user_match_id": "nil",
      "inserted_at": "nil",
      "group": "APPLICATION_CONTROL",
      "appSha256": "nil",
      "core_remedy_processPath": "nil",
      "threat_id": "nil",
      "core_remedy_type": "nil",
      "core_remedy_items_totalItems": "0",
      "endpoint_id": "2d5e5b88-8071-42b3-9214-e49660c8b715",
      "type": "Event::Endpoint::Application::Detected"
    },
    {
      "event_TS": "2024-10-04 23:40:37",
      "dhost": "C4307BCKMKM6Y6C",
      "description": "Controlled application detected: Microsoft Powershell (System tool)",
      "duid": "5d6a668f3c266910a3517f1e",
      "filepath": "nil",
      "core_remedy_sophosPid": "nil",
      "core_remedy_result": "nil",
      "product_name": "sophos central",
      "customer_id": "f0d877a8-a5e2-41ae-a9a9-2656086a8bb5",
      "format": "CEF",
      "threat_cleanable": "nil",
      "threat": "nil",
      "product_version": "1.0",
      "endpoint_type": "computer",
      "severity": "1",
      "created_at": "nil",
      "core_remedy_descriptor": "nil",
      "source_info_ip": "10.0.4.248",
      "core_remedy_suspendResult": "nil",
      "appCerts": "nil",
      "endpoint_java_id": "nil",
      "origin": "nil",
      "suser": "Administrator",
      "datastream": "event",
      "vendor_name": "sophos",
      "detection_identity_name": "nil",
      "ComputerName": "C4307BCKMKM6Y6C",
      "format_version": "0",
      "name": "nil",
      "endpoint_platform": "nil",
      "user_match_id": "nil",
      "inserted_at": "nil",
      "group": "APPLICATION_CONTROL",
      "appSha256": "nil",
      "core_remedy_processPath": "nil",
      "threat_id": "nil",
      "core_remedy_type": "nil",
      "core_remedy_items_totalItems": "0",
      "endpoint_id": "2d5e5b88-8071-42b3-9214-e49660c8b715",
      "type": "Event::Endpoint::Application::Detected"
    },
    {
      "event_TS": "2024-10-04 23:40:08",
      "dhost": "C4307B8DQ9BP23F",
      "description": "Controlled application detected: Microsoft Powershell (System tool)",
      "duid": "5d6a668f3c266910a3517f1e",
      "filepath": "nil",
      "core_remedy_sophosPid": "nil",
      "core_remedy_result": "nil",
      "product_name": "sophos central",
      "customer_id": "f0d877a8-a5e2-41ae-a9a9-2656086a8bb5",
      "format": "CEF",
      "threat_cleanable": "nil",
      "threat": "nil",
      "product_version": "1.0",
      "endpoint_type": "computer",
      "severity": "1",
      "created_at": "nil",
      "core_remedy_descriptor": "nil",
      "source_info_ip": "10.0.4.248",
      "core_remedy_suspendResult": "nil",
      "appCerts": "nil",
      "endpoint_java_id": "nil",
      "origin": "nil",
      "suser": "Administrator",
      "datastream": "event",
      "vendor_name": "sophos",
      "detection_identity_name": "nil",
      "ComputerName": "C4307B8DQ9BP23F",
      "format_version": "0",
      "name": "nil",
      "endpoint_platform": "nil",
      "user_match_id": "nil",
      "inserted_at": "nil",
      "group": "APPLICATION_CONTROL",
      "appSha256": "nil",
      "core_remedy_processPath": "nil",
      "threat_id": "nil",
      "core_remedy_type": "nil",
      "core_remedy_items_totalItems": "0",
      "endpoint_id": "2d5e5b88-8071-42b3-9214-e49660c8b715",
      "type": "Event::Endpoint::Application::Detected"
    },
    {
      "event_TS": "2024-10-04 23:39:46",
      "dhost": "C4307B8DQ9BP23F",
      "description": "Controlled application detected: Microsoft Powershell (System tool)",
      "duid": "5d6a668f3c266910a3517f1e",
      "filepath": "nil",
      "core_remedy_sophosPid": "nil",
      "core_remedy_result": "nil",
      "product_name": "sophos central",
      "customer_id": "f0d877a8-a5e2-41ae-a9a9-2656086a8bb5",
      "format": "CEF",
      "threat_cleanable": "nil",
      "threat": "nil",
      "product_version": "1.0",
      "endpoint_type": "computer",
      "severity": "1",
      "created_at": "nil",
      "core_remedy_descriptor": "nil",
      "source_info_ip": "10.0.4.248",
      "core_remedy_suspendResult": "nil",
      "appCerts": "nil",
      "endpoint_java_id": "nil",
      "origin": "nil",
      "suser": "Administrator",
      "datastream": "event",
      "vendor_name": "sophos",
      "detection_identity_name": "nil",
      "ComputerName": "C4307B8DQ9BP23F",
      "format_version": "0",
      "name": "nil",
      "endpoint_platform": "nil",
      "user_match_id": "nil",
      "inserted_at": "nil",
      "group": "APPLICATION_CONTROL",
      "appSha256": "nil",
      "core_remedy_processPath": "nil",
      "threat_id": "nil",
      "core_remedy_type": "nil",
      "core_remedy_items_totalItems": "0",
      "endpoint_id": "2d5e5b88-8071-42b3-9214-e49660c8b715",
      "type": "Event::Endpoint::Application::Detected"
    },
    {
      "event_TS": "2024-10-04 23:35:11",
      "dhost": "C4307B8DQ9BP23F",
      "description": "Controlled application detected: Microsoft Powershell (System tool)",
      "duid": "5d6a668f3c266910a3517f1e",
      "filepath": "nil",
      "core_remedy_sophosPid": "nil",
      "core_remedy_result": "nil",
      "product_name": "sophos central",
      "customer_id": "f0d877a8-a5e2-41ae-a9a9-2656086a8bb5",
      "format": "CEF",
      "threat_cleanable": "nil",
      "threat": "nil",
      "product_version": "1.0",
      "endpoint_type": "computer",
      "severity": "1",
      "created_at": "nil",
      "core_remedy_descriptor": "nil",
      "source_info_ip": "10.0.4.248",
      "core_remedy_suspendResult": "nil",
      "appCerts": "nil",
      "endpoint_java_id": "nil",
      "origin": "nil",
      "suser": "Administrator",
      "datastream": "event",
      "vendor_name": "sophos",
      "detection_identity_name": "nil",
      "ComputerName": "C4307B8DQ9BP23F",
      "format_version": "0",
      "name": "nil",
      "endpoint_platform": "nil",
      "user_match_id": "nil",
      "inserted_at": "nil",
      "group": "APPLICATION_CONTROL",
      "appSha256": "nil",
      "core_remedy_processPath": "nil",
      "threat_id": "nil",
      "core_remedy_type": "nil",
      "core_remedy_items_totalItems": "0",
      "endpoint_id": "2d5e5b88-8071-42b3-9214-e49660c8b715",
      "type": "Event::Endpoint::Application::Detected"
    },
    {
      "event_TS": "2024-10-04 23:33:01",
      "dhost": "C4307B8DQ9BP23F",
      "description": "Controlled application detected: Microsoft Powershell (System tool)",
      "duid": "5d6a668f3c266910a3517f1e",
      "filepath": "nil",
      "core_remedy_sophosPid": "nil",
      "core_remedy_result": "nil",
      "product_name": "sophos central",
      "customer_id": "f0d877a8-a5e2-41ae-a9a9-2656086a8bb5",
      "format": "CEF",
      "threat_cleanable": "nil",
      "threat": "nil",
      "product_version": "1.0",
      "endpoint_type": "computer",
      "severity": "1",
      "created_at": "nil",
      "core_remedy_descriptor": "nil",
      "source_info_ip": "10.0.4.248",
      "core_remedy_suspendResult": "nil",
      "appCerts": "nil",
      "endpoint_java_id": "nil",
      "origin": "nil",
      "suser": "Administrator",
      "datastream": "event",
      "vendor_name": "sophos",
      "detection_identity_name": "nil",
      "ComputerName": "C4307B8DQ9BP23F",
      "format_version": "0",
      "name": "nil",
      "endpoint_platform": "nil",
      "user_match_id": "nil",
      "inserted_at": "nil",
      "group": "APPLICATION_CONTROL",
      "appSha256": "nil",
      "core_remedy_processPath": "nil",
      "threat_id": "nil",
      "core_remedy_type": "nil",
      "core_remedy_items_totalItems": "0",
      "endpoint_id": "2d5e5b88-8071-42b3-9214-e49660c8b715",
      "type": "Event::Endpoint::Application::Detected"
    },
    {
      "event_TS": "2024-10-04 23:25:31",
      "dhost": "C4307BCKMKM6Y6C",
      "description": "Controlled application detected: Microsoft Powershell (System tool)",
      "duid": "5d6a668f3c266910a3517f1e",
      "filepath": "nil",
      "core_remedy_sophosPid": "nil",
      "core_remedy_result": "nil",
      "product_name": "sophos central",
      "customer_id": "f0d877a8-a5e2-41ae-a9a9-2656086a8bb5",
      "format": "CEF",
      "threat_cleanable": "nil",
      "threat": "nil",
      "product_version": "1.0",
      "endpoint_type": "computer",
      "severity": "1",
      "created_at": "nil",
      "core_remedy_descriptor": "nil",
      "source_info_ip": "10.0.4.248",
      "core_remedy_suspendResult": "nil",
      "appCerts": "nil",
      "endpoint_java_id": "nil",
      "origin": "nil",
      "suser": "Administrator",
      "datastream": "event",
      "vendor_name": "sophos",
      "detection_identity_name": "nil",
      "ComputerName": "C4307BCKMKM6Y6C",
      "format_version": "0",
      "name": "nil",
      "endpoint_platform": "nil",
      "user_match_id": "nil",
      "inserted_at": "nil",
      "group": "APPLICATION_CONTROL",
      "appSha256": "nil",
      "core_remedy_processPath": "nil",
      "threat_id": "nil",
      "core_remedy_type": "nil",
      "core_remedy_items_totalItems": "0",
      "endpoint_id": "2d5e5b88-8071-42b3-9214-e49660c8b715",
      "type": "Event::Endpoint::Application::Detected"
    },
    {
      "event_TS": "2024-10-04 23:20:55",
      "dhost": "C4307BCKMKM6Y6C",
      "description": "Controlled application detected: Microsoft Powershell (System tool)",
      "duid": "5d6a668f3c266910a3517f1e",
      "filepath": "nil",
      "core_remedy_sophosPid": "nil",
      "core_remedy_result": "nil",
      "product_name": "sophos central",
      "customer_id": "f0d877a8-a5e2-41ae-a9a9-2656086a8bb5",
      "format": "CEF",
      "threat_cleanable": "nil",
      "threat": "nil",
      "product_version": "1.0",
      "endpoint_type": "computer",
      "severity": "1",
      "created_at": "nil",
      "core_remedy_descriptor": "nil",
      "source_info_ip": "10.0.4.248",
      "core_remedy_suspendResult": "nil",
      "appCerts": "nil",
      "endpoint_java_id": "nil",
      "origin": "nil",
      "suser": "Administrator",
      "datastream": "event",
      "vendor_name": "sophos",
      "detection_identity_name": "nil",
      "ComputerName": "C4307BCKMKM6Y6C",
      "format_version": "0",
      "name": "nil",
      "endpoint_platform": "nil",
      "user_match_id": "nil",
      "inserted_at": "nil",
      "group": "APPLICATION_CONTROL",
      "appSha256": "nil",
      "core_remedy_processPath": "nil",
      "threat_id": "nil",
      "core_remedy_type": "nil",
      "core_remedy_items_totalItems": "0",
      "endpoint_id": "2d5e5b88-8071-42b3-9214-e49660c8b715",
      "type": "Event::Endpoint::Application::Detected"
    }
  ]



  //visualize title 
  toTitleCase(str: any) {
    return str.toLowerCase().split(' ').map((word: any) => {
      return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
  }

  // <------- chart variables ------------>
  handleprovided3chartdataerror = new ErrorMsgHandler();
  nodeSelected = false
  // templates = [
  //   {
  //     "label": "source", "temp": {
  //       "id": "1",
  //       "node": "source",
  //       "count": 0,
  //       "bubbles": [],
  //       "filters": [],
  //       "children": [],
  //       "predecessors": [],
  //       "relation": "contributingSource",
  //       "instantFilter": [
  //         {
  //           "label": "Show all",
  //           "isEnable": 1,
  //           "ifilter_desc": "",
  //           "ifilter_type": "",
  //           "isSelected": false,
  //           "category": "limit"
  //         },],
  //       "instantFilterDisplay": [
  //         {
  //           "label": "Show all",
  //           "isEnable": 1,
  //           "ifilter_desc": "",
  //           "ifilter_type": "",
  //           "isSelected": false,
  //           "category": "limit"
  //         },]
  //     }
  //   },
  //   {
  //     "label": "Episodes", "temp": {
  //       "id": "1",
  //       "node": "Episodes",
  //       "count": 0,
  //       "bubbles": [],
  //       "filters": [],
  //       "children": [],
  //       "predecessors": [],
  //       "relation": "isInEpisode",
  //       "instantFilter": [
  //         {
  //           "label": "Show all",
  //           "isEnable": 1,
  //           "ifilter_desc": "",
  //           "ifilter_type": "",
  //           "isSelected": false,
  //           "category": "limit"
  //         },],
  //       "instantFilterDisplay": [
  //         {
  //           "label": "Show all",
  //           "isEnable": 1,
  //           "ifilter_desc": "",
  //           "ifilter_type": "",
  //           "isSelected": false,
  //           "category": "limit"
  //         },]
  //     }
  //   },
  //   {
  //     "label": "fields", "temp": {
  //       "id": "1",
  //       "node": "fields",
  //       "count": 0,
  //       "bubbles": [],
  //       "filters": [],
  //       "children": [],
  //       "predecessors": [],
  //       "relation": "hasField",
  //       "instantFilter": [
  //         {
  //           "label": "Show all",
  //           "isEnable": 1,
  //           "ifilter_desc": "",
  //           "ifilter_type": "",
  //           "isSelected": false,
  //           "category": "limit"
  //         },],
  //       "instantFilterDisplay": [
  //         {
  //           "label": "Show all",
  //           "isEnable": 1,
  //           "ifilter_desc": "",
  //           "ifilter_type": "",
  //           "isSelected": false,
  //           "category": "limit"
  //         },]
  //     }
  //   },
  //   {
  //     "label": "Episodes -> source", "temp": {
  //       "id": "1",
  //       "node": "Episodes",
  //       "count": 0,
  //       "bubbles": [],
  //       "filters": [],
  //       "children": [
  //         {
  //           "id": "1_1",
  //           "node": "source",
  //           "count": 0,
  //           "bubbles": [],
  //           "filters": [],
  //           "children": [],
  //           "predecessorIds": [],
  //           "relation": "contributingSource",
  //           "instantFilter": [
  //             {
  //               "label": "Show all",
  //               "isEnable": 1,
  //               "ifilter_desc": "",
  //               "ifilter_type": "",
  //               "isSelected": false,
  //               "category": "limit"
  //             },],
  //           "instantFilterDisplay": [
  //             {
  //               "label": "Show all",
  //               "isEnable": 1,
  //               "ifilter_desc": "",
  //               "ifilter_type": "",
  //               "isSelected": false,
  //               "category": "limit"
  //             },]
  //         }
  //       ],
  //       "predecessors": [],
  //       "relation": "isInEpisode",
  //       "instantFilter": [
  //         {
  //           "label": "Show all",
  //           "isEnable": 1,
  //           "ifilter_desc": "",
  //           "ifilter_type": "",
  //           "isSelected": false,
  //           "category": "limit"
  //         },],
  //       "instantFilterDisplay": [
  //         {
  //           "label": "Show all",
  //           "isEnable": 1,
  //           "ifilter_desc": "",
  //           "ifilter_type": "",
  //           "isSelected": false,
  //           "category": "limit"
  //         },]
  //     }
  //   },
  //   {
  //     "label": "Episodes -> source -> fields", "temp": {
  //       "id": "1",
  //       "node": "Episodes",
  //       "count": 0,
  //       "bubbles": [],
  //       "filters": [],

  //       "children": [
  //         {
  //           "id": "1_1",
  //           "node": "source",
  //           "count": 0,
  //           "bubbles": [],
  //           "filters": [],
  //           "children": [
  //             {
  //               "id": "1_1_1",
  //               "node": "fields",
  //               "count": 0,
  //               "bubbles": [],
  //               "filters": [],
  //               "children": [],
  //               "predecessorIds": [],
  //               "relation": "hasField",
  //               "instantFilter": [
  //                 {
  //                   "label": "Show all",
  //                   "isEnable": 1,
  //                   "ifilter_desc": "",
  //                   "ifilter_type": "",
  //                   "isSelected": false,
  //                   "category": "limit"
  //                 },],
  //               "instantFilterDisplay": [
  //                 {
  //                   "label": "Show all",
  //                   "isEnable": 1,
  //                   "ifilter_desc": "",
  //                   "ifilter_type": "",
  //                   "isSelected": false,
  //                   "category": "limit"
  //                 },]
  //             }
  //           ],
  //           "predecessorIds": [],
  //           "relation": "contributingSource",
  //           "instantFilter": [
  //             {
  //               "label": "Show all",
  //               "isEnable": 1,
  //               "ifilter_desc": "",
  //               "ifilter_type": "",
  //               "isSelected": false,
  //               "category": "limit"
  //             },],
  //           "instantFilterDisplay": [
  //             {
  //               "label": "Show all",
  //               "isEnable": 1,
  //               "ifilter_desc": "",
  //               "ifilter_type": "",
  //               "isSelected": false,
  //               "category": "limit"
  //             },]
  //         }
  //       ],
  //       "predecessors": [],
  //       "relation": "isInEpisode",
  //       "instantFilter": [
  //         {
  //           "label": "Show all",
  //           "isEnable": 1,
  //           "ifilter_desc": "",
  //           "ifilter_type": "",
  //           "isSelected": false,
  //           "category": "limit"
  //         },],
  //       "instantFilterDisplay": [
  //         {
  //           "label": "Show all",
  //           "isEnable": 1,
  //           "ifilter_desc": "",
  //           "ifilter_type": "",
  //           "isSelected": false,
  //           "category": "limit"
  //         },]
  //     }
  //   },
  //   {
  //     "label": "fields -> source -> Episodes", "temp": {
  //       "id": "1",
  //       "node": "fields",
  //       "count": 0,
  //       "bubbles": [],
  //       "filters": [],
  //       "children": [
  //         {
  //           "id": "1_1",
  //           "node": "source",
  //           "count": 0,
  //           "bubbles": [],
  //           "filters": [],
  //           "children": [
  //             {
  //               "id": "1_1_1",
  //               "node": "Episodes",
  //               "count": 0,
  //               "bubbles": [],
  //               "filters": [],
  //               "children": [],
  //               "predecessorIds": [],
  //               "relation": "isInEpisode",
  //               "instantFilter": [
  //                 {
  //                   "label": "Show all",
  //                   "isEnable": 1,
  //                   "ifilter_desc": "",
  //                   "ifilter_type": "",
  //                   "isSelected": false,
  //                   "category": "limit"
  //                 },],
  //               "instantFilterDisplay": [
  //                 {
  //                   "label": "Show all",
  //                   "isEnable": 1,
  //                   "ifilter_desc": "",
  //                   "ifilter_type": "",
  //                   "isSelected": false,
  //                   "category": "limit"
  //                 },]
  //             }
  //           ],
  //           "predecessorIds": [],
  //           "relation": "contributingSource",
  //           "instantFilter": [
  //             {
  //               "label": "Show all",
  //               "isEnable": 1,
  //               "ifilter_desc": "",
  //               "ifilter_type": "",
  //               "isSelected": false,
  //               "category": "limit"
  //             },],
  //           "instantFilterDisplay": [
  //             {
  //               "label": "Show all",
  //               "isEnable": 1,
  //               "ifilter_desc": "",
  //               "ifilter_type": "",
  //               "isSelected": false,
  //               "category": "limit"
  //             },]
  //         }
  //       ],
  //       "predecessors": [],
  //       "relation": "hasField",
  //       "instantFilter": [
  //         {
  //           "label": "Show all",
  //           "isEnable": 1,
  //           "ifilter_desc": "",
  //           "ifilter_type": "",
  //           "isSelected": false,
  //           "category": "limit"
  //         },],
  //       "instantFilterDisplay": [
  //         {
  //           "label": "Show all",
  //           "isEnable": 1,
  //           "ifilter_desc": "",
  //           "ifilter_type": "",
  //           "isSelected": false,
  //           "category": "limit"
  //         },]
  //     }
  //   }
  // ]
  templates = [
    {
      "label": "Episodes", "temp": {
        "id": "1",
        "node": "Episodes",
        "count": 0,
        "total_alert_count": 0,
        "bubbles": [],
        "filters": [],
        "children": [],
        "predecessors": [],
        "relation": "isInEpisode",
        "advanceFilter": [],
        "advanceFilterDisplay": [],
        "instantFilter": [
          {
            "label": "Show all",
            "isEnable": 1,
            "ifilter_desc": "",
            "ifilter_type": "",
            "isSelected": false,
            "category": "limit"
          },],
        "instantFilterDisplay": [
          {
            "label": "Show all",
            "isEnable": 1,
            "ifilter_desc": "",
            "ifilter_type": "",
            "isSelected": false,
            "category": "limit"
          },]
      }
    }
  ]
  legendState: boolean = true;
  nodeFilter: Subject<any> = new Subject();
  nodeInstantFilter: Subject<any> = new Subject();
  relationMenuRef: cdkOverlayRef;
  cf
  chartData: any = JSON.parse(JSON.stringify(this.templates[0].temp))
  // chartData: any = {}
  nodes = 0
  bubbleThreshold = 100
  alertNodes = []
  relationList = []
  selectedNode;
  previousselectedNode = "0";
  lastClickedNode;
  disableRelations = [];
  dimensionRelation = {
    "series": { "source": "emitted by", "fields": "has character", "Episodes": "occured in" },
    "source": { "other_series": "has other series", "Episodes": "occured in" },
    "fields": { "other_series": "in other series" },
    "Episodes": { "source": "has sources", "other_series": "has other series" },
  }
  relations = {
    "series": ["source", "fields", "Episodes"],
    "source": ["other_series", "Episodes"],
    "fields": ["other_series"],
    "Episodes": ["source", "other_series"],
    "other_series": [],
  }

  load_default_chartdata() {
    this.chartData = JSON.parse(JSON.stringify(this.templates[0].temp))
  }

  getParentNode() {
    var rootObjArr = []
    var rootObj
    var bynode = this.cf.dimension((p) => { return p.group; });
    bynode.filterExact(this.lastClickedNode.structural_parent);
    bynode.top(Infinity).forEach((data) => {
      if (data.bubble)
        rootObjArr.push(data.value)
      else
        rootObjArr = []
      rootObj = { ...data }
    })
    bynode.filterAll();
    rootObj.value = rootObjArr
    return rootObj

  }

  getRootNode() {
    let rootObj = null;
    let bynode = this.cf.dimension((p) => { return p.dimension; });
    bynode.filterExact("series");
    bynode.top(Infinity).forEach((data) => {
      rootObj = data
    })
    bynode.filterAll();
    rootObj.value = []
    return rootObj
  }

  // <------- chart variables end -------->
  createtoastmsg(msg: any) {
    this.toasterservice.show({
      type: msg.type,
      text: msg.text
    })
  }
  expandEventsPanel() {
    this.eventsPanel = FactsheetEventsPanel.expand;
    // this.changeCanvas()
  }
  collapseEventsPanel() {
    this.eventsPanel = FactsheetEventsPanel.collapse;
    // if (this.eventsPanel == 0 || this.eventsPanel == 2) {
    //   this.eventsPanel = FactsheetEventsPanel.collapse;
    // } else if (this.eventsPanel == 1) {
    //   this.eventsPanel = FactsheetEventsPanel.closed;
    // }
    this.changeCanvas()
  }

  closeEventsPanel() {
    // this.currentIndex = 1
    // this.isVisibleEvents = false;
    this.alertEventsListView = true;
    // this.eventlist.length = 0;
    this.eventsPanel = FactsheetEventsPanel.closed;
    this.changeCanvas()
  }

  resetEventsPagination() {
    this.eventspagenumber = 1;
    this.eventspagelength = 1;
  }



  collapseSummaryPanel() {
    this.summaryPanel = FactsheetSummaryPanel.collapse;
    this.changeCanvas()
  }

  closeSummaryPanel() {
    if (this.summaryPanel == 1) {
      this.summaryPanel = FactsheetSummaryPanel.closed;
    } else if (this.summaryPanel == 2) {
      this.summaryPanel = FactsheetSummaryPanel.collapse;
    }
    this.changeCanvas()
  }

  expandSummaryPanel() {
    this.summaryPanel = FactsheetSummaryPanel.expand;
    this.changeCanvas()
  }

  resetFactsheetPanels() {
    this.summaryPanel = FactsheetSummaryPanel.collapse;
    this.eventsPanel = FactsheetEventsPanel.closed;
    //relation chart variables
    this.chartData = JSON.parse(JSON.stringify(this.templates[0].temp));
    // this.nodeinfo = null;
    this.advanced_filter_values = this.get_events_timerange();
    this.nodesummarydata = {
      series: [],
    };
    this.currentIndex = 0
    this.alertSummaryCountDetails = { has_alerts: 0, has_no_alerts: 0 }
    this.chart_ref_no = "";
    this.alertstatus.setValue('0')
    this.assigned_user.setValue([])
    this.eventlist.length = 0;
    this.SelectAllAlerts = false;
    this.eventsSelectAll.setValue(false);
    this.eventWorkFlowInfo.selectedAlerts = {}
    this.filteredNodesumarryArray = []
    this.previousselectedNode="0"
    this.handleDetaildataerror.seterror(false,'')
  }

  openAdvancedFilter(origin: any, mode: number, isAction: boolean) {
//console.log("Click")

    // console.log("openAdvancedFilter======", !this.isAction, this.alertvarService.advanced_filter_values, this.alertvarService.alertsheetmeta.filterOptions.advanceFilter)

    if (!isAction) {
      const ref: cdkOverlayRef = this.openOverlay(origin, AdvanceFilterComponent,
        [
          { ...this.advanced_filter_values },
          { ...this.alertsheetmeta.filterOptions.advanceFilter }, mode]
        , mode ? ["45vh", "25vw"] : ["35vh", "55vw"]);
      // , ["45vh", "25vw"]);
      ref.$selectedValue.subscribe(response => {
        this.resetPreviousNodeSelection()
        this.advanced_filter_values = response;
        this.advancedFilterChange.next(null);
      })
    }
  }

  openOverlay(origin: any, component: any, componentInputs: any, dimensions: any) {
    this.overLayRef = this.cdkoverlayDialog.open({
      data: componentInputs,
      height: dimensions[0],
      width: dimensions[1],
    },
      origin, component)
    return this.overLayRef;
  }
  //form groups for alert filters
  alertFilters = new FormGroup({
    external: new FormGroup({
      severity: new FormControl(''),
      timezone: new FormControl(''),
      timerange: new FormControl(''),
      platform: new FormControl(''),
      impactedHost: new FormControl({})
    }),
    internal: new FormGroup({
      alertcount: new FormControl(0),
      alertpercentage: new FormControl(0)
    }),
    itemPerPage: new FormControl(0),
    page: new FormControl(1)
  })

  alertpagelength: number = 1;
  tagsSearchcontrol = new FormControl('');
  filter_changes_state = false;

  get external() {
    return this.alertFilters.get('external') as FormGroup
  }

  alertSummaryData: any; // holds alert summary data;
  ruledetailsdata = {};
  tagmapping = {};
  distag = {};
  alertRows: any[] = [];

  alertscollapsedata = {
    alertRowsData: [],
    selectedrows: new Subject(),
    selectedalert: null,
  }
  getaction() {
    return this.ruleForm.get('actions') as FormGroup
  }


  processdefaultalertfilters() {
    this.tagsMapping(this.commondata.tags.mapping);
    this.tagsSearch('');
    this.external.addControl('tags', this.structureTagsService.createTagControl(this.distag));
    this.getaddTags().addControl('tags', this.structureTagsService.createTagControl(this.distag));
    this.alertFilters.patchValue(this.alertsheetmeta.alertDefaults);
    this.gethost();
    for (let i = 0; i < this.commondata.tags.tagslist.length; i++) {
      this.tagmapping[this.commondata.tags.tagslist[i]["val"]] = this.commondata.tags.tagslist[i];
    }
  }

  gethost() {
    const hostlist = JSON.parse(JSON.stringify(this.sharedService.hostlist));
    const impactedhost = {
      selectedHosts: [...hostlist],
      toggleControl: false,
      uniqueHostsLength: hostlist.length,
      selectedTags: [],
      excludedHosts: {}
    }
    this.external.controls['impactedHost'].setValue(impactedhost)
  }

  tagsMapping(tagsdata: any) {
    for (let tag in tagsdata) {
      this.distag[tag] = []
    }
  }

  tagsSearch(val: string) {
    this.commondata.tags.tagslist.forEach((ele: any) => {
      const searchterm: string = ele.disp
      if (searchterm?.toLowerCase().includes(val.toLowerCase())) {
        this.distag[ele.parent].push(ele)
      }
    })
  }

  setdefault = this.processdefaultalertfilters();

  resetalertvariablesoff() {
    this.alertSummaryData = null; // holds alert summary data;
    this.factSheetOpened = false;
    this.ruledetailsdata = {};
    this.tagmapping = {};
    this.distag = {};
    this.alertRows.length = 0;
    this.alertpagelength = 1;
    this.alertselectedIndex = 0;
    this.alertEventSelectedIndex = 0;
  }

  resetalertvariableon() {
    this.filter_changes_state = false;
    this.processdefaultalertfilters();
  }

  resetPreviousNodeSelection() {
    this.previousselectedNode = "0";
  }
  factsheetSelectedIndex = 0;

  //advanced filter variables

  // relativetime_highlight: string = "Last 24 Hour";
  // default_advanced_filter = {
  //   "time_range": {
  //     "disp": "Last 24 Hour",
  //     "value": [
  //       -1,
  //       "hour",
  //       24
  //     ]
  //   },
  //   "time_interval": {
  //     "disp": "10 mins",
  //     "value": 10
  //   },
  //   "count": 50,
  //   "users": [
  //     "unassigned"
  //   ],
  //   "status": [
  //     "open"
  //   ],
  //   "highlight": "Last 24 Hour"
  // }
  default_advanced_filter = this.alertsheetmeta.filterOptions.default_advanced_filter
  advanced_filter_values: any = this.get_events_timerange();

  get_events_timerange() {
    const events_timerange = this.calculate_timerange(this.default_advanced_filter.time_range.value)
    return {
      // start_time: '2024-09-01 00:00:00',
      start_time: events_timerange[0],
      // end_time: '2024-09-01 01:00:00',
      end_time: events_timerange[1],
      time_interval: this.default_advanced_filter.time_interval,
      count: this.default_advanced_filter.count,
      users: [...this.default_advanced_filter.users],
      status: [...this.default_advanced_filter.status],
      highlight: this.default_advanced_filter.highlight
    }
  }
  calulate_current_timeinterval(start_time: any, time_interval: any) {
    this.timezoneservice.toUtcTimeZonefromUser(start_time)
    const end_time = this.timezoneservice.toUtcTimeZonefromUser(start_time).add(time_interval, 'minutes').format('YYYY-MM-DD HH:mm:ss');
    return [start_time, end_time]
  }



  calculate_timerange(time: any) {
    const currentusertime = this.timezoneservice.getcurrentuserTime();
    // const currentusertime = this.timezoneservice.getUtcTime();

    if (time[1] == "hour") {
      const start_date = currentusertime.clone().subtract(time[2], 'hour');
      return [start_date.format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
    } else if (time[1] == "today") {
      const start_date = currentusertime.clone();
      return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
    } else if (time[1] == "yesterday") {
      const start_date = currentusertime.clone().subtract(1, 'days');
      return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), start_date.endOf('day').format('YYYY-MM-DD HH:mm:ss')];
    } else {
      const previousdate = currentusertime.clone().subtract(time[2], 'days');
      return [previousdate.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
    }
  }


  // advanced filter time options metadata
  // advanced_filter_timeMeta = {
  //   "relative_time_options": [
  //     {
  //       "disp": "Last 1 hour",
  //       "value": [
  //         -1,
  //         "hour",
  //         1
  //       ]
  //     },
  //     {
  //       "disp": "Last 3 Hour",
  //       "value": [
  //         -1,
  //         "hour",
  //         3
  //       ]
  //     },
  //     {
  //       "disp": "Last 24 Hour",
  //       "value": [
  //         -1,
  //         "hour",
  //         24
  //       ]
  //     },
  //     {
  //       "disp": "Today",
  //       "value": [
  //         0,
  //         "today",
  //         0
  //       ]
  //     },
  //     {
  //       "disp": "Yesterday",
  //       "value": [
  //         -1,
  //         "yesterday",
  //         1
  //       ]
  //     },
  //     {
  //       "disp": "last 7 Days",
  //       "value": [
  //         -1,
  //         "day",
  //         6
  //       ]
  //     },
  //     {
  //       "disp": "Last 30 Days",
  //       "value": [
  //         -1,
  //         "day",
  //         29
  //       ]
  //     },
  //     {
  //       "disp": "Last 90 Days",
  //       "value": [
  //         -1,
  //         "day",
  //         89
  //       ]
  //     }
  //   ],
  //   "intervals": [
  //     {
  //       "disp": "10 mins",
  //       "value": 10
  //     },
  //     {
  //       "disp": "30 mins",
  //       "value": 30
  //     },
  //     {
  //       "disp": "1 hour",
  //       "value": 60
  //     },
  //     {
  //       "disp": "3 hours",
  //       "value": 180
  //     }
  //   ],
  // }

  //actionmanagement
  alertactionmanagement = new AlertActionManagement();

  //ruleerrorhandler
  handleprovideruledataerror = new ErrorMsgHandler();

  //overview errorhandler
  handleOverviewdataerror = new ErrorMsgHandler();

  handleDetaildataerror = new ErrorMsgHandler();

  // events errorhandler
  handleprovideeventsdataerror = new ErrorMsgHandler();

  resetfactsheetvariablesoff() {
    this.resetEventsPagination();
    // this.isVisibleEvents = false;
    // this.isEventsTable = false;
    this.detailsSearch.setValue("", { emitEvent: false });
    this.notesSearch.setValue("", { emitEvent: false });
    this.alertEventsSearch.setValue("", { emitEvent: false })

    this.detailsSelectall.setValue(false, { emitEvent: false });
    this.overviewDetails.length = this.nodesummarydata.series.length = 0;
    this.eventlist.length = 0;
    //relation chart variables
    this.chartData = JSON.parse(JSON.stringify(this.templates[0].temp));
    // this.nodeinfo = null;
    this.advanced_filter_values = this.get_events_timerange();
    this.nodesummarydata = {
      series: [],
    };
    this.currentIndex = 0


  }

  resetfactsheetvariableson() {
    this.eventsItemperpage.setValue(this.alertsheetmeta.factsheetMeta.paginationDefault, { emitEvent: false });
    this.get_events_timerange();
  }
  alertUserReset() {
    this.resetalertvariablesoff();
    this.resetfactsheetvariablesoff();
    this.resetFactsheetPanels();
    this.alertService.customerChangeLogggedOff.next(true);
  }

  create_eventReqobj() {
    return {
      alertId: this.alertscollapsedata.selectedalert.alertId,
      season_time: [this.timezoneservice.toUtcTimeZonefromUser(this.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
      episode_duration: this.advanced_filter_values.time_interval.value,
      pagination: true,
      page: this.eventspagenumber,
      itemperpage: this.eventsItemperpage.getRawValue(),
      hosts: this.alertscollapsedata.selectedalert.hosts,
      platform: this.alertscollapsedata.selectedalert.platform,
      ref_no: this.chart_ref_no,
      // ref_no:"2ac896ae",
      selectednode: this.nodeinfo.id,
      search: 'all',
      // status: [],
      status: [this.alertstatus.value],
      // assigned_user: this.assigned_user.value,
      assigned_user: this.alertstatus.value != '0' ? this.assigned_user.value : [],
      state: [],
      template: { ...this.template_structure }
    }
  }

  getBubbleValues(node) {
    var nodeList = []
    node.bubbles.forEach(element => {
      // console.log("->",element)
      nodeList.push(element.value)
    });
    return nodeList
  }

  build_eventReqobj() {

    var nodeList = this.getBubbleValues(this.nodeinfo)
    return { ...this.create_eventReqobj() }

    // if (this.nodeinfo['node'] == "other_series") {
    //   // let parentnode = this.getParentNode();
    //   const reqobj = {
    //     ...this.create_eventReqobj(),
    //     node: this.nodeinfo["node"],
    //     node_list: nodeList,
    //     node_type: nodeList.length ? "value" : "all",
    //   }

    //   if (reqobj['node'] == "fields") {
    //     reqobj['node_list'] = [];
    //     reqobj['node_type'] = "all";
    //   }

    //   return reqobj;

    // } else if (this.nodeinfo['node'] == "fields" || this.nodeinfo['node'] == "series") {
    //   return {
    //     ...this.create_eventReqobj(),
    //     node: this.nodeinfo["node"],
    //     node_list: [],
    //     node_type: "all",
    //   }

    // } else {
    //   return {
    //     ...this.create_eventReqobj(),
    //     node: this.nodeinfo["node"],
    //     node_list: nodeList,
    //     node_type: nodeList.length ? "value" : "all",
    //   }
    // }
  }
  changeCanvas() {
    setTimeout(() => {
      const svg = d3.select(".connector").node();
      let svgWidth = d3.style(svg, 'width');
      let svgHeight = d3.style(svg, 'height');

      // set the svg width, height to the rect width, height
      d3.select("#exploration-zoom-pan-canvas").style("width", svgWidth)
      d3.select("#exploration-zoom-pan-canvas").style("height", svgHeight);
      this.centerAlign()

    }, 200);

  }
  centerAlign() {
    // make the node to center
    let bbox = d3.select("#exploration-zoom-pan-canvas").node().getBBox();
    const svgWidth = bbox.width;
    const svgHeight = bbox.height;
    // make the node to center
    bbox = d3.select("#exploration-graph").node().getBBox();
    const graphWidth = bbox.width;
    // const graphHeight = bbox.height;
    // Calculate the position to center the graph
    const centerX = (svgWidth / 2) - (graphWidth / 2);
    const centerY = (svgHeight / 2);

    // Apply the translation
    d3.select("#exploration-graph").attr("transform", `translate(${centerX}, ${centerY})`);
  }

  //format chart label values
  format_axiz_lable(option) {
    let temp_option = {}
    if ('yAxis' in option && 'type' in option['yAxis'] && option['yAxis']['type'] == 'value') {
      temp_option = {
        ...option, ...{
          'yAxis': {
            'axisLabel': {
              'formatter': function (value) {
                if (value >= 1000000000) {
                  return echarts.format.addCommas((value / 1000000000).toFixed(1)) + ' B';
                } else if (value >= 1000000) {
                  return echarts.format.addCommas((value / 1000000).toFixed(1)) + ' M';
                } else if (value >= 1000) {
                  return echarts.format.addCommas((value / 1000).toFixed(1)) + ' K';
                } else {
                  return echarts.format.addCommas(value);
                }

              }
            }
          }
        }
      }
      return temp_option
    }
    else if ('angleAxis' in option && 'type' in option['angleAxis'] && option['angleAxis']['type'] == 'value') {
      temp_option = {
        ...option, ...{
          'angleAxis': {
            'axisLabel': {
              'formatter': function (value) {
                if (value >= 1000000000) {
                  return echarts.format.addCommas((value / 1000000000).toFixed(1)) + ' B';
                } else if (value >= 1000000) {
                  return echarts.format.addCommas((value / 1000000).toFixed(1)) + ' M';
                } else if (value >= 1000) {
                  return echarts.format.addCommas((value / 1000).toFixed(1)) + ' K';
                } else {
                  return echarts.format.addCommas(value);
                }

              }
            },
            'axisLine': {
              'lineStyle': {
                'opacity': 0.2
              }
            }
          }
        }
      }
      return temp_option;
    }
    else if ('xAxis' in option && 'type' in option['xAxis'] && option['xAxis']['type'] == 'value') {
      temp_option = {
        ...option, ...{
          'xAxis': {
            'axisLabel': {
              'formatter': function (value) {
                if (value >= 1000000000) {
                  return echarts.format.addCommas((value / 1000000000).toFixed(1)) + ' B';
                } else if (value >= 1000000) {
                  return echarts.format.addCommas((value / 1000000).toFixed(1)) + ' M';
                } else if (value >= 1000) {
                  return echarts.format.addCommas((value / 1000).toFixed(1)) + ' K';
                } else {
                  return echarts.format.addCommas(value);
                }

              }
            }
          }
        }
      }
      return temp_option;
    }
    else return option;
  }

  calculatepagelength(alertcount: number, itemPerPage: number) {
    if (alertcount) {
      return Math.ceil(alertcount / itemPerPage);
    } else {
      return 1;
    }
  }

  RemoveAllSelectedEvents() {
    this.AlertEvents
    for (let alerts in this.AlertEvents) {
      this.AlertEvents[alerts].isSelected = false
    }
    this.alertWorkFlowInfo.selectedAlerts = {}
    this.alertWorkFlowInfo.alertKeys_list = []
    this.alertWorkFlowInfo.paginationDataWorkFlowAlert = []
    this.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(false, { emitEvent: false })
    this.eventsSelectAll.setValue(false, { emitEvent: false })
  }
  RemoveOnlySelectedEvents() {
    let selected = []
    for (let alerts in this.alertWorkFlowInfo.selectedAlerts) {
      if (this.alertWorkFlowInfo.selectedAlerts[alerts].isSelected)
        selected.push(alerts)
    }
    selected.forEach(element => {
      if (this.AlertEvents.hasOwnProperty(element)) {
        this.AlertEvents[element].isSelected = false
        this.eventsSelectAll.setValue(false, { emitEvent: false })
      }
      // console.log("====", this.alertWorkFlowInfo.selectedAlerts.hasOwnProperty(element) && this.alertWorkFlowInfo.selectedAlerts[element].isSelected)
      if (this.alertWorkFlowInfo.selectedAlerts.hasOwnProperty(element) && this.alertWorkFlowInfo.selectedAlerts[element].isSelected) {
        delete this.alertWorkFlowInfo.selectedAlerts[element]
        this.alertWorkFlowInfo.alertKeys_list?.splice(this.alertWorkFlowInfo.alertKeys_list.indexOf(element), 1)
      }

    });
    this.alertWorkFlowInfo.paginationDataWorkFlowAlert = Object.keys(this.alertWorkFlowInfo.selectedAlerts)
    this.alertWorkFlowInfo.paginationDataWorkFlowAlert.sort((a, b) => parseInt(b) - parseInt(a));
    this.alertWorkFlowInfo.selectedeventspagenumber = 1
    this.alertWorkFlowInfo.selectedeventspagelength = this.calculatepagelength(this.alertWorkFlowInfo.paginationDataWorkFlowAlert.length, this.alertWorkFlowInfo.alertWorkFloweventsItemperpage.value)
    //console.log("RemoveOnlySelectedEvents=====", this.alertWorkFlowInfo.paginationDataWorkFlowAlert)
  }

  resetAlertSearchObj() {
    this.alertSearchInfo = {
      invalidSearchKeyStatus: false,
      alertSearchState: false,
      searchval: '',
      status: [],
      statusreason: []
    }
  }
  alertCountPerPeriodDefault = [{ "period": "Morning Start (7:00 AM - 9:00 AM)", "count": 0, "percentage": "0" },
  { "period": "Mid-Morning (9:00 AM - 12:00 PM)", "count": 0, "percentage": "0" },
  { "period": "Early Afternoon (12:00 PM - 2:00 PM)", "count": 0, "percentage": "0" },
  { "period": "Late Afternoon (2:00 PM - 6:00 PM)", "count": 0, "percentage": "0" },
  { "period": "Evening (6:00 PM - 9:00 PM)", "count": 0, "percentage": "0" },
  { "period": "Night (9:00 PM - 12:00 AM)", "count": 0, "percentage": "0" },
  { "period": "Late Night (12:00 AM - 3:00 AM)", "count": 0, "percentage": "0" },
  { "period": "Pre-Dawn (3:00 AM - 6:00 AM)", "count": 0, "percentage": "0" },
  { "period": "Early Morning (6:00 AM - 7:00 AM)", "count": 0, "percentage": "0" }]
  alertCountPerPeriod = JSON.parse(JSON.stringify(this.alertCountPerPeriodDefault))
  getAlertCountPerTimePeriod(data) {
    this.alertCountPerPeriod = JSON.parse(JSON.stringify(this.alertCountPerPeriodDefault))

    data.bubbles.forEach(element => {
      var dateobj = this.timezoneservice.getuserTimegivenepoch(element.value)
      var hour = dateobj.hour()
      if (hour >= 7 && hour < 9) {
        this.alertCountPerPeriod[0].count = this.alertCountPerPeriod[0].count + element.count
        this.alertCountPerPeriod[0].percentage = ((this.alertCountPerPeriod[0].count / data.total_alert_count) * 100).toFixed(2)
      }
      else if (hour >= 9 && hour < 12) {
        this.alertCountPerPeriod[1].count = this.alertCountPerPeriod[1].count + element.count
        this.alertCountPerPeriod[1].percentage = ((this.alertCountPerPeriod[1].count / data.total_alert_count) * 100).toFixed(2)

      }
      else if (hour >= 12 && hour < 14) {
        this.alertCountPerPeriod[2].count = this.alertCountPerPeriod[2].count + element.count
        this.alertCountPerPeriod[2].percentage = ((this.alertCountPerPeriod[2].count / data.total_alert_count) * 100).toFixed(2)

      }
      else if (hour >= 14 && hour < 18) {
        this.alertCountPerPeriod[3].count = this.alertCountPerPeriod[3].count + element.count
        this.alertCountPerPeriod[3].percentage = ((this.alertCountPerPeriod[3].count / data.total_alert_count) * 100).toFixed(2)

      }
      else if (hour >= 18 && hour < 21) {
        this.alertCountPerPeriod[4].count = this.alertCountPerPeriod[4].count + element.count
        this.alertCountPerPeriod[4].percentage = ((this.alertCountPerPeriod[4].count / data.total_alert_count) * 100).toFixed(2)

      }
      else if (hour >= 21) {
        this.alertCountPerPeriod[5].count = this.alertCountPerPeriod[5].count + element.count
        this.alertCountPerPeriod[5].percentage = ((this.alertCountPerPeriod[5].count / data.total_alert_count) * 100).toFixed(2)

      }
      else if (hour >= 0 && hour < 3) {
        this.alertCountPerPeriod[6].count = this.alertCountPerPeriod[6].count + element.count
        this.alertCountPerPeriod[6].percentage = ((this.alertCountPerPeriod[6].count / data.total_alert_count) * 100).toFixed(2)

      }
      else if (hour >= 3 && hour < 6) {
        this.alertCountPerPeriod[7].count = this.alertCountPerPeriod[7].count + element.count
        this.alertCountPerPeriod[7].percentage = ((this.alertCountPerPeriod[7].count / data.total_alert_count) * 100).toFixed(2)

      }
      else if (hour >= 6 && hour < 7) {
        this.alertCountPerPeriod[8].count = this.alertCountPerPeriod[8].count + element.count
        this.alertCountPerPeriod[8].percentage = ((this.alertCountPerPeriod[8].count / data.total_alert_count) * 100).toFixed(2)

      }
    });
  }
  numberWithCommas(x) {
    return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
  }
  getRangeGroup(num) {
    if (num <= 0) return 0; // handle invalid or zero input
    return Math.ceil(num / 100);
  }
  updateSelectedEventAlerts(event: any, alertKey: string, index, evt?) {
    evt?.stopPropagation()

// console.log(this.AlertEvents)

//consoe.log("Event List =----> ",this.AlertEventsKeyList)
//consoe.log({event})
//consoe.log({alertKey})
//consoe.log({index})
//consoe.log({evt})
    // this.alertvarservice.SelectAllAlerts = false
    let tempevent = JSON.parse(JSON.stringify(event))
    let tempkey = alertKey
    let batch = this.getRangeGroup((this.eventsItemperpage.value * this.eventspagenumber) - this.eventsItemperpage.value + index + 1)
    if (batch in this.eventWorkFlowInfo.selectedAlerts) {
      if (tempkey in this.eventWorkFlowInfo.selectedAlerts[batch]) {
        // delete this.alertvarservice.eventWorkFlowInfo.selectedAlerts[batch][tempkey]
        this.eventWorkFlowInfo.selectedAlerts[batch][tempkey]["selected"] = !this.eventWorkFlowInfo.selectedAlerts[batch][tempkey]["selected"]
      }
      else this.eventWorkFlowInfo.selectedAlerts[batch][tempkey] = { alerttime: tempevent['alerttime'], seq_no: tempevent['seq_no'], selected: true }
      //console.log("updateSelectedEventAlerts batch", batch, tempkey, this.alertvarservice.eventWorkFlowInfo.selectedAlerts)
    }
    else {
      let repobj = {}
      repobj[tempkey] = { alerttime: tempevent['alerttime'], seq_no: tempevent['seq_no'], selected: true }
      // //console.log("updateSelectedAlertEvents", repobj)
      this.eventWorkFlowInfo.selectedAlerts = { ...this.eventWorkFlowInfo.selectedAlerts, [batch]: repobj }
      //console.log("updateSelectedEventAlerts no batch", batch, tempkey, this.alertvarservice.eventWorkFlowInfo.selectedAlerts)
    }
    //console.log("updateSelectedEventAlerts", batch, tempkey, this.alertvarservice.eventWorkFlowInfo.selectedAlerts)

//consoe.log("Selected Alerts =----> ",this.eventWorkFlowInfo.selectedAlerts)
  }
  isAlertInCurrentPageSlected(pagenumber, eventNumber, itemsper_page, eventRefKey) {
    let batch = this.getRangeGroup((itemsper_page * pagenumber) - itemsper_page + eventNumber + 1)
    // console.log("Batch =---->",batch)
    // console.log("EventWorkFlowInfo =----> ", this.eventWorkFlowInfo)
    //console.log("isAlertInCurrentPageSlected", batch, eventRefKey)
    if (this.eventWorkFlowInfo.selectedAlerts.hasOwnProperty(batch) && this.eventWorkFlowInfo.selectedAlerts[batch].hasOwnProperty(eventRefKey) && this.eventWorkFlowInfo.selectedAlerts[batch][eventRefKey]["selected"]) {
      return true
    }
    return false
  }
  clearAllPageClick() {
    Object.keys(this.eventWorkFlowInfo.selectedAlerts).map((batch: any) => {
      Object.keys(this.eventWorkFlowInfo.selectedAlerts[batch]).map((alertkey: any) => {
        delete this.eventWorkFlowInfo.selectedAlerts[batch][alertkey]
      })
    })
    // Object.keys(this.alertvarservice.AlertEvents).map((key: string) => {
    //   this.alertvarservice.AlertEvents[key].isSelected = false
    // })
    // this.alertvarservice.alertWorkFlowInfo.alertKeys_list = []
    // this.alertvarservice.alertWorkFlowInfo.selectedAlerts = {}
    // this.alertvarservice.alertWorkFlowInfo.paginationDataWorkFlowAlert = []
    // this.alertvarservice.alertWorkFlowInfo.selectedeventspagenumber = 1
    // this.alertvarservice.alertWorkFlowInfo.selectedeventspagelength = 1
    // this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(false, { emitEvent: false })
    this.eventsSelectAll.setValue(false, { emitEvent: false })
    this.SelectAllAlerts = false
  }
}
